"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomFieldAllowedCharacterSet = exports.CustomFieldAccessType = exports.CoverImageTitlePosition = exports.CoverImageStyle = exports.ConversationStyle = exports.ContributorRelation = exports.ContributionMethod = exports.ContentWorkflowState = exports.ContentType = exports.ContentMetricDrillDownByType = exports.ContentBorder = exports.ConditionName = exports.ComponentPageScope = exports.ComponentMarkupLanguage = exports.ComponentFetchedState = exports.CommunityNodeAccess = exports.CommunityAppEnum = exports.ClientAuthMethod = exports.ChangeType = exports.CategoryReportSortMetric = exports.ButtonFillStyle = exports.BranchType = exports.BorderLocation = exports.BooleanQueryOperator = exports.BooleanCustomFormFieldType = exports.BlogPostsReportSortMetric = exports.BlogBoardReportSortMetric = exports.BanType = exports.BanStatus = exports.BackgroundSize = exports.BackgroundRepeat = exports.BackgroundPosition = exports.BackgroundOrigin = exports.BackgroundExtension = exports.BackgroundClip = exports.BackgroundAttachment = exports.AuthMethod = exports.AuthMechanism = exports.AsyncReportStatus = exports.AsyncReportSort = exports.AssetFeature = exports.ArchivedDateEnum = exports.AppName = exports.AgeOfIdeaSince = exports.AgeOfIdeaCutoffPeriod = exports.ActionType = exports.Access = exports.AbuseReportReason = exports.AbuseModerationUserAction = exports.AbuseModerationMessageAction = void 0;
exports.InvalidConditionReason = exports.InvalidActionReason = exports.Interval = exports.InteractionStatus = exports.IntListCustomFormFieldType = exports.IntCustomFormFieldType = exports.InheritedAccess = exports.ImageAssociationType = exports.ImageAssociatedEntityType = exports.IdeasReportSortMetric = exports.IdeaStatusLabelType = exports.IdeaBoardReportSortMetric = exports.Groups = exports.GroupHubReportSortMetric = exports.GroupHubConversationStyle = exports.ForumDiscussionsReportSortMetric = exports.ForumBoardReportSortMetric = exports.FormInputType = exports.FormGroupFieldSeparator = exports.FormActionButtonsPosition = exports.FormActionButtonBarPosition = exports.FontStyle = exports.FontSource = exports.FloatListCustomFormFieldType = exports.FloatCustomFormFieldType = exports.FilteredEntityType = exports.FilterOperator = exports.FilterEventEntityEnum = exports.FilterAction = exports.FieldType = exports.FieldSettableForAction = exports.FieldInputControl = exports.FieldDataType = exports.FetchedContentInterval = exports.EntityType = exports.EntityFormAction = exports.EndpointHttpMethod = exports.EndpointCachingFor = exports.EndpointBodyType = exports.DrillDownTrafficMetricEnum = exports.DrillDownContentMetricEnum = exports.DisableSpacing = exports.DeliveryDay = exports.DeleteStatus = exports.DateUnit = exports.DateTimeCustomFormFieldType = exports.CustomizationPointType = exports.CustomizationPointScopeType = exports.CustomQuiltReturnType = exports.CustomFieldValueType = void 0;
exports.RankStyle = exports.RankStatus = exports.QuiltItemType = exports.QueryOperator = exports.QueryFieldIndexAnalyzedOption = exports.ProductStatus = exports.ProductCategoryStatus = exports.PrivateNoteModerationAction = exports.PostMessageType = exports.PolicyHostLocation = exports.PlaceTypeEnum = exports.PageViewsByType = exports.PageScriptProvider = exports.PageScriptGroup = exports.Operator = exports.OccasionsReportSortMetric = exports.OccasionType = exports.OccasionStatusFilterType = exports.OccasionBoardReportSortMetric = exports.OEmbedType = exports.NumberQueryOperator = exports.NodeType = exports.NodeAccess = exports.NewTopicsByRepliesReportSortMetric = exports.NavbarPosition = exports.ModerationStyle = exports.ModerationStatus = exports.ModerationPermissions = exports.ModerationAction = exports.ModeratingActorType = exports.MetricResponseMessageCode = exports.MetricNodeScope = exports.MetricName = exports.MetricFilterName = exports.MetricDimension = exports.MetricContentScope = exports.MetricConfigName = exports.MembershipType = exports.MemberReportSortMetric = exports.MemberRegistrationStatus = exports.MediaType = exports.ManualSortOrderType = exports.MailTemplateName = exports.MailTemplateField = exports.LongCustomFormFieldType = exports.LinkType = exports.LinkTarget = exports.LeaderboardTimeRange = exports.InviteType = exports.InviteStatus = void 0;
exports.WorkstreamColumnFilterType = exports.WorkflowAction = exports.VisualStyle = exports.VisibilityScope = exports.VideoAssociationType = exports.UserType = exports.UserRepliesSortOrder = exports.UserOnlineStatus = exports.UploadedImageAssociatedEntityType = exports.UploadVideoStatus = exports.Trigger = exports.TrendingTopicsByRepliesReportSortMetric = exports.TrafficMetricDrillDownByType = exports.TopicsByRepliesType = exports.TopicTrendingWindow = exports.TokenMethod = exports.ToggleState = exports.TimeUnit = exports.TextTransform = exports.TextItemGroup = exports.TextAlignment = exports.TagType = exports.TkbBoardReportSortMetric = exports.TkbArticlesReportSortMetric = exports.StringQueryOperator = exports.StringListCustomFormFieldType = exports.StringCustomFormFieldType = exports.StatusType = exports.SpecialChecksValidation = exports.SpamStatus = exports.SortDirection = exports.SignedInStatus = exports.ShowProfileInformationTo = exports.ShowOnlineStatusTo = exports.ShowEmailTo = exports.SectionLayoutType = exports.SectionEditLevel = exports.SearchSnippetKey = exports.SchedulingInterval = exports.SalesforceUserSyncStatus = exports.SalesforceUserSyncAction = exports.RsvpResponse = exports.ReportType = exports.ReplyType = exports.RepliesSortOrder = exports.RepliesFormat = exports.RejectReason = exports.RegistrationStatusAccessLevel = exports.RegistrationStatus = exports.ReadState = void 0;
exports.ZoomMeetingStatus = exports.WorkstreamScope = void 0;
/** An enumeration that defines the moderation action on abuse message */
var AbuseModerationMessageAction;
(function (AbuseModerationMessageAction) {
    AbuseModerationMessageAction["Ignore"] = "IGNORE";
    AbuseModerationMessageAction["Reject"] = "REJECT";
})(AbuseModerationMessageAction || (exports.AbuseModerationMessageAction = AbuseModerationMessageAction = {}));
/** An enumeration that defines the moderation action on abuse user */
var AbuseModerationUserAction;
(function (AbuseModerationUserAction) {
    AbuseModerationUserAction["BanMember"] = "BAN_MEMBER";
    AbuseModerationUserAction["Ignore"] = "IGNORE";
})(AbuseModerationUserAction || (exports.AbuseModerationUserAction = AbuseModerationUserAction = {}));
/** An enumeration representing reported reason. */
var AbuseReportReason;
(function (AbuseReportReason) {
    AbuseReportReason["Harassment"] = "HARASSMENT";
    AbuseReportReason["HateSpeech"] = "HATE_SPEECH";
    AbuseReportReason["MisleadingOrFalseInformation"] = "MISLEADING_OR_FALSE_INFORMATION";
    AbuseReportReason["NudityOrSexualActivity"] = "NUDITY_OR_SEXUAL_ACTIVITY";
    AbuseReportReason["Plagiarism"] = "PLAGIARISM";
    AbuseReportReason["ScamOrFraud"] = "SCAM_OR_FRAUD";
    AbuseReportReason["SomethingElse"] = "SOMETHING_ELSE";
    AbuseReportReason["Spam"] = "SPAM";
})(AbuseReportReason || (exports.AbuseReportReason = AbuseReportReason = {}));
/** Enum that defines all the access level for a permission. */
var Access;
(function (Access) {
    Access["Assign"] = "ASSIGN";
    Access["Denied"] = "DENIED";
    Access["Granted"] = "GRANTED";
    Access["Inherited"] = "INHERITED";
})(Access || (exports.Access = Access = {}));
var ActionType;
(function (ActionType) {
    ActionType["ApproveRequest"] = "APPROVE_REQUEST";
    ActionType["AssignRoles"] = "ASSIGN_ROLES";
    ActionType["FollowNode"] = "FOLLOW_NODE";
    ActionType["InviteToNode"] = "INVITE_TO_NODE";
})(ActionType || (exports.ActionType = ActionType = {}));
/** The cutoff period after which age of ideas will all be aggregated into one period */
var AgeOfIdeaCutoffPeriod;
(function (AgeOfIdeaCutoffPeriod) {
    AgeOfIdeaCutoffPeriod["OneYear"] = "ONE_YEAR";
    AgeOfIdeaCutoffPeriod["SixMonths"] = "SIX_MONTHS";
})(AgeOfIdeaCutoffPeriod || (exports.AgeOfIdeaCutoffPeriod = AgeOfIdeaCutoffPeriod = {}));
/** Age of Idea Since */
var AgeOfIdeaSince;
(function (AgeOfIdeaSince) {
    AgeOfIdeaSince["Creation"] = "CREATION";
    AgeOfIdeaSince["LastUpdate"] = "LAST_UPDATE";
})(AgeOfIdeaSince || (exports.AgeOfIdeaSince = AgeOfIdeaSince = {}));
/** The app name of the Aurora app being Queried or Mutataed. */
var AppName;
(function (AppName) {
    AppName["Admin"] = "ADMIN";
    AppName["Enduser"] = "ENDUSER";
})(AppName || (exports.AppName = AppName = {}));
/** Enumeration for filtering archived messages based on the archived date. */
var ArchivedDateEnum;
(function (ArchivedDateEnum) {
    /** Messages archived in the last 24 hours. */
    ArchivedDateEnum["Past_24Hours"] = "PAST_24_HOURS";
    /** Messages archived in the last month. */
    ArchivedDateEnum["PastMonth"] = "PAST_MONTH";
    /** Messages archived in the last week. */
    ArchivedDateEnum["PastWeek"] = "PAST_WEEK";
    /** Messages archived in the last year. */
    ArchivedDateEnum["PastYear"] = "PAST_YEAR";
})(ArchivedDateEnum || (exports.ArchivedDateEnum = ArchivedDateEnum = {}));
/** Represents a logical grouping of assets by feature. */
var AssetFeature;
(function (AssetFeature) {
    /** Assets that are used by the Avatars feature. */
    AssetFeature["Avatars"] = "AVATARS";
    /** Assets that are used by the Components feature. */
    AssetFeature["Components"] = "COMPONENTS";
    /** Assets that can be used by customizations. */
    AssetFeature["Custom"] = "CUSTOM";
    /**
     * Assets that are used by the Custom Content feature.
     * @deprecated use COMPONENTS instead.
     */
    AssetFeature["CustomContent"] = "CUSTOM_CONTENT";
    /** Assets that can be used by page scripts. */
    AssetFeature["Pagescripts"] = "PAGESCRIPTS";
    /** Assets that can be used by Props. */
    AssetFeature["Props"] = "PROPS";
    /** Assets that are used by the Quilts feature. */
    AssetFeature["Quilts"] = "QUILTS";
    /** Assets that are used by the Quilt wrappers feature. */
    AssetFeature["Quiltwrappers"] = "QUILTWRAPPERS";
    /** Assets that are used by the Themes feature. */
    AssetFeature["Themes"] = "THEMES";
})(AssetFeature || (exports.AssetFeature = AssetFeature = {}));
var AsyncReportSort;
(function (AsyncReportSort) {
    /** Sorts the reports based on the submission time */
    AsyncReportSort["SubmissionTime"] = "SUBMISSION_TIME";
})(AsyncReportSort || (exports.AsyncReportSort = AsyncReportSort = {}));
var AsyncReportStatus;
(function (AsyncReportStatus) {
    AsyncReportStatus["Abandoned"] = "ABANDONED";
    AsyncReportStatus["Completed"] = "COMPLETED";
    AsyncReportStatus["Failed"] = "FAILED";
    AsyncReportStatus["InProgress"] = "IN_PROGRESS";
    AsyncReportStatus["Pending"] = "PENDING";
    AsyncReportStatus["Queued"] = "QUEUED";
    AsyncReportStatus["Scheduled"] = "SCHEDULED";
    AsyncReportStatus["Stopped"] = "STOPPED";
})(AsyncReportStatus || (exports.AsyncReportStatus = AsyncReportStatus = {}));
/** Represents the Auth mechanism for any provider in the community. */
var AuthMechanism;
(function (AuthMechanism) {
    /** THe JWT SSO authentication mechanism */
    AuthMechanism["JwtSso"] = "JWT_SSO";
    /** The Khoros SSO authentication mechanism */
    AuthMechanism["KhorosSso"] = "KHOROS_SSO";
    /** The local username-password authentication */
    AuthMechanism["Local"] = "LOCAL";
    /** THe OIDCSS SSO authentication mechanism */
    AuthMechanism["OidcssSso"] = "OIDCSS_SSO";
    /** The SAML SSO authentication mechanism */
    AuthMechanism["SamlSso"] = "SAML_SSO";
})(AuthMechanism || (exports.AuthMechanism = AuthMechanism = {}));
/** Auth method request type */
var AuthMethod;
(function (AuthMethod) {
    /** Basic auth method */
    AuthMethod["Basic"] = "BASIC";
    /** Bearer auth method */
    AuthMethod["Bearer"] = "BEARER";
    /** None auth method */
    AuthMethod["None"] = "NONE";
})(AuthMethod || (exports.AuthMethod = AuthMethod = {}));
/** Defines an enum for the background-attachment css property. */
var BackgroundAttachment;
(function (BackgroundAttachment) {
    BackgroundAttachment["Fixed"] = "FIXED";
    BackgroundAttachment["Local"] = "LOCAL";
    BackgroundAttachment["Scroll"] = "SCROLL";
})(BackgroundAttachment || (exports.BackgroundAttachment = BackgroundAttachment = {}));
/** Defines an enum for the background-clip css property. */
var BackgroundClip;
(function (BackgroundClip) {
    BackgroundClip["BorderBox"] = "BORDER_BOX";
    BackgroundClip["ContentBox"] = "CONTENT_BOX";
    BackgroundClip["PaddingBox"] = "PADDING_BOX";
})(BackgroundClip || (exports.BackgroundClip = BackgroundClip = {}));
/** Defines an enum for the background extension. */
var BackgroundExtension;
(function (BackgroundExtension) {
    /** Background extends to the width of the browser. */
    BackgroundExtension["WidthOfBrowser"] = "WIDTH_OF_BROWSER";
    /** Background extends to the width of the page content. */
    BackgroundExtension["WidthOfPageContent"] = "WIDTH_OF_PAGE_CONTENT";
})(BackgroundExtension || (exports.BackgroundExtension = BackgroundExtension = {}));
/** Defines an enum for the background-origin css property. */
var BackgroundOrigin;
(function (BackgroundOrigin) {
    BackgroundOrigin["BorderBox"] = "BORDER_BOX";
    BackgroundOrigin["ContentBox"] = "CONTENT_BOX";
    BackgroundOrigin["PaddingBox"] = "PADDING_BOX";
})(BackgroundOrigin || (exports.BackgroundOrigin = BackgroundOrigin = {}));
/** Background position enum. */
var BackgroundPosition;
(function (BackgroundPosition) {
    BackgroundPosition["CenterBottom"] = "CENTER_BOTTOM";
    BackgroundPosition["CenterCenter"] = "CENTER_CENTER";
    BackgroundPosition["CenterTop"] = "CENTER_TOP";
    BackgroundPosition["LeftBottom"] = "LEFT_BOTTOM";
    BackgroundPosition["LeftCenter"] = "LEFT_CENTER";
    BackgroundPosition["LeftTop"] = "LEFT_TOP";
    BackgroundPosition["RightBottom"] = "RIGHT_BOTTOM";
    BackgroundPosition["RightCenter"] = "RIGHT_CENTER";
    BackgroundPosition["RightTop"] = "RIGHT_TOP";
})(BackgroundPosition || (exports.BackgroundPosition = BackgroundPosition = {}));
/** Background repeat enum. */
var BackgroundRepeat;
(function (BackgroundRepeat) {
    BackgroundRepeat["NoRepeat"] = "NO_REPEAT";
    BackgroundRepeat["Repeat"] = "REPEAT";
    BackgroundRepeat["RepeatX"] = "REPEAT_X";
    BackgroundRepeat["RepeatY"] = "REPEAT_Y";
})(BackgroundRepeat || (exports.BackgroundRepeat = BackgroundRepeat = {}));
/** Background size enum. */
var BackgroundSize;
(function (BackgroundSize) {
    BackgroundSize["Auto"] = "AUTO";
    BackgroundSize["Contain"] = "CONTAIN";
    BackgroundSize["Cover"] = "COVER";
})(BackgroundSize || (exports.BackgroundSize = BackgroundSize = {}));
/** Member ban status enum. */
var BanStatus;
(function (BanStatus) {
    BanStatus["Banned"] = "BANNED";
    BanStatus["NotBanned"] = "NOT_BANNED";
})(BanStatus || (exports.BanStatus = BanStatus = {}));
/** Enum consisting of different types of Bans. */
var BanType;
(function (BanType) {
    /** Both of the Temporary and Permanent bans. */
    BanType["All"] = "ALL";
    /** Bans where duration of ban isn't mentioned and the affected users are permanently banned. */
    BanType["Permanent"] = "PERMANENT";
    /** Bans for which duration is mentioned. */
    BanType["Temporary"] = "TEMPORARY";
})(BanType || (exports.BanType = BanType = {}));
/** Defines enum for all applicable sort metrics for blogBoardReport. */
var BlogBoardReportSortMetric;
(function (BlogBoardReportSortMetric) {
    /** Number of the blog comments. */
    BlogBoardReportSortMetric["CommentsPublished"] = "COMMENTS_PUBLISHED";
    /** Likes given. */
    BlogBoardReportSortMetric["KudosGiven"] = "KUDOS_GIVEN";
    /** Number of subscriptions made on nodes. */
    BlogBoardReportSortMetric["NodeSubscriptions"] = "NODE_SUBSCRIPTIONS";
    /**
     * A page view is counted each time a browser requests a page, regardless of the device type or whether the page is
     * cached. Page Views approximates user behavior and therefore excludes non-human requests (Web crawlers,
     * robots, RSS feeds, REST API calls, ActiveCast calls, and LevelUp requests).
     */
    BlogBoardReportSortMetric["PageViews"] = "PAGE_VIEWS";
    /** Number of the blog posts published. */
    BlogBoardReportSortMetric["PostsPublished"] = "POSTS_PUBLISHED";
    /** Unique number of visitors. */
    BlogBoardReportSortMetric["UniqueVisitors"] = "UNIQUE_VISITORS";
    /** A visit is one or more page views over time by a uniquely identified client (visitor). */
    BlogBoardReportSortMetric["Visits"] = "VISITS";
})(BlogBoardReportSortMetric || (exports.BlogBoardReportSortMetric = BlogBoardReportSortMetric = {}));
var BlogPostsReportSortMetric;
(function (BlogPostsReportSortMetric) {
    /** Number of the blog comments. */
    BlogPostsReportSortMetric["CommentsPublished"] = "COMMENTS_PUBLISHED";
    /** Likes given. */
    BlogPostsReportSortMetric["KudosGiven"] = "KUDOS_GIVEN";
    /**
     * A page view is counted each time a browser requests a page, regardless of the device type or whether the page is
     * cached. Page views approximates user behavior and therefore excludes non-human requests (Web crawlers,
     * robots, RSS feeds, REST API calls, ActiveCast calls, and LevelUp requests).
     */
    BlogPostsReportSortMetric["PageViews"] = "PAGE_VIEWS";
    /** Number of subscriptions made on posts. */
    BlogPostsReportSortMetric["PostSubscriptions"] = "POST_SUBSCRIPTIONS";
    /** Unique number of visitors. */
    BlogPostsReportSortMetric["UniqueVisitors"] = "UNIQUE_VISITORS";
    /** A visit is one or more page views over time by a uniquely identified client (visitor). */
    BlogPostsReportSortMetric["Visits"] = "VISITS";
})(BlogPostsReportSortMetric || (exports.BlogPostsReportSortMetric = BlogPostsReportSortMetric = {}));
/** Enumerates the types of boolean form fields */
var BooleanCustomFormFieldType;
(function (BooleanCustomFormFieldType) {
    /** A check field. */
    BooleanCustomFormFieldType["Check"] = "CHECK";
})(BooleanCustomFormFieldType || (exports.BooleanCustomFormFieldType = BooleanCustomFormFieldType = {}));
/** Enumerates the possible Query Operators for Boolean values. */
var BooleanQueryOperator;
(function (BooleanQueryOperator) {
    /** Equals (=) */
    BooleanQueryOperator["Eq"] = "EQ";
    /** Not Equals (!=) */
    BooleanQueryOperator["Neq"] = "NEQ";
})(BooleanQueryOperator || (exports.BooleanQueryOperator = BooleanQueryOperator = {}));
/** Border location enum. */
var BorderLocation;
(function (BorderLocation) {
    BorderLocation["Both"] = "BOTH";
    BorderLocation["Bottom"] = "BOTTOM";
    BorderLocation["Top"] = "TOP";
})(BorderLocation || (exports.BorderLocation = BorderLocation = {}));
/** Specifies type of branches Git repository will return. */
var BranchType;
(function (BranchType) {
    /** All remote branch 'git fetch -r'. */
    BranchType["All"] = "ALL";
    /** Bugfix branch. */
    BranchType["Bugfix"] = "BUGFIX";
    /** Feature branch. */
    BranchType["Feature"] = "FEATURE";
})(BranchType || (exports.BranchType = BranchType = {}));
/** Defines an enum for the button fill styles. */
var ButtonFillStyle;
(function (ButtonFillStyle) {
    ButtonFillStyle["Filled"] = "FILLED";
    ButtonFillStyle["Outlined"] = "OUTLINED";
})(ButtonFillStyle || (exports.ButtonFillStyle = ButtonFillStyle = {}));
/** Defines enum for all applicable sort metrics for categoryReport. */
var CategoryReportSortMetric;
(function (CategoryReportSortMetric) {
    /** Number of the blog articles published. */
    CategoryReportSortMetric["BlogPostsPublished"] = "BLOG_POSTS_PUBLISHED";
    /** Number of the forum topics. */
    CategoryReportSortMetric["ForumDiscussionsPublished"] = "FORUM_DISCUSSIONS_PUBLISHED";
    /** Number of ideas submitted. */
    CategoryReportSortMetric["IdeasSubmitted"] = "IDEAS_SUBMITTED";
    /** Number of idea votes. */
    CategoryReportSortMetric["IdeaVotes"] = "IDEA_VOTES";
    /** Likes given. */
    CategoryReportSortMetric["KudosGiven"] = "KUDOS_GIVEN";
    /** Number of subscriptions made on nodes. */
    CategoryReportSortMetric["NodeSubscriptions"] = "NODE_SUBSCRIPTIONS";
    /** Number of occasion created. */
    CategoryReportSortMetric["OccasionsCreated"] = "OCCASIONS_CREATED";
    /** Attendance of the occasion */
    CategoryReportSortMetric["OccasionAttendance"] = "OCCASION_ATTENDANCE";
    /** Number of Occasion Attending RSVPs */
    CategoryReportSortMetric["OccasionRsvpAttending"] = "OCCASION_RSVP_ATTENDING";
    /** Number of Occasion Interested RSVPs */
    CategoryReportSortMetric["OccasionRsvpInterested"] = "OCCASION_RSVP_INTERESTED";
    /**
     * A page view is counted each time a browser requests a page, regardless of the device type or whether the page is
     * cached. Page views approximates user behavior and therefore excludes non-human requests (Web crawlers,
     * robots, RSS feeds, REST API calls, ActiveCast calls, and LevelUp requests).
     */
    CategoryReportSortMetric["PageViews"] = "PAGE_VIEWS";
    /** Number of subscriptions made on posts. */
    CategoryReportSortMetric["PostSubscriptions"] = "POST_SUBSCRIPTIONS";
    /** Number of replies accepted as solution to the parent topic. */
    CategoryReportSortMetric["SolutionsAccepted"] = "SOLUTIONS_ACCEPTED";
    /** Number of the KB articles posted. */
    CategoryReportSortMetric["TkbArticlesPublished"] = "TKB_ARTICLES_PUBLISHED";
    /** Unique number of visitors. */
    CategoryReportSortMetric["UniqueVisitors"] = "UNIQUE_VISITORS";
    /** A visit is one or more page views over time by a uniquely identified client (visitor). */
    CategoryReportSortMetric["Visits"] = "VISITS";
})(CategoryReportSortMetric || (exports.CategoryReportSortMetric = CategoryReportSortMetric = {}));
/** Specifies change type of file or directory between two branches or tags or commits. */
var ChangeType;
(function (ChangeType) {
    /** Newly added file or directory. */
    ChangeType["Add"] = "ADD";
    /** Copied file or directory. */
    ChangeType["Copy"] = "COPY";
    /** Deleted file or directory. */
    ChangeType["Delete"] = "DELETE";
    /** Updated or modified file or directory. */
    ChangeType["Modify"] = "MODIFY";
    /** Renamed file or directory. */
    ChangeType["Rename"] = "RENAME";
})(ChangeType || (exports.ChangeType = ChangeType = {}));
/** Auth method used by client for getting access token */
var ClientAuthMethod;
(function (ClientAuthMethod) {
    /** client secret basic mode */
    ClientAuthMethod["ClientSecretBasic"] = "CLIENT_SECRET_BASIC";
    /** client secret post mode */
    ClientAuthMethod["ClientSecretPost"] = "CLIENT_SECRET_POST";
})(ClientAuthMethod || (exports.ClientAuthMethod = ClientAuthMethod = {}));
/** Community app indicating the interaction styles */
var CommunityAppEnum;
(function (CommunityAppEnum) {
    CommunityAppEnum["Blog"] = "BLOG";
    CommunityAppEnum["Contest"] = "CONTEST";
    CommunityAppEnum["Forum"] = "FORUM";
    CommunityAppEnum["Group"] = "GROUP";
    CommunityAppEnum["Idea"] = "IDEA";
    CommunityAppEnum["Occasion"] = "OCCASION";
    CommunityAppEnum["Qanda"] = "QANDA";
    CommunityAppEnum["Review"] = "REVIEW";
    CommunityAppEnum["Tkb"] = "TKB";
})(CommunityAppEnum || (exports.CommunityAppEnum = CommunityAppEnum = {}));
/** Enum that defines access level for a permission at community level. */
var CommunityNodeAccess;
(function (CommunityNodeAccess) {
    CommunityNodeAccess["Denied"] = "DENIED";
    CommunityNodeAccess["Granted"] = "GRANTED";
})(CommunityNodeAccess || (exports.CommunityNodeAccess = CommunityNodeAccess = {}));
/**
 * Used to specify whether to return only components that ARE URL-fetched,
 * only components that are NOT URL-fetched,
 * or BOTH.
 */
var ComponentFetchedState;
(function (ComponentFetchedState) {
    /** Return both URL-fetched and NOT URL-fetched components. */
    ComponentFetchedState["Both"] = "BOTH";
    /** Only return components that are URL-fetched. */
    ComponentFetchedState["Fetched"] = "FETCHED";
    /** Only return components that are NOT URL-fetched. */
    ComponentFetchedState["NotFetched"] = "NOT_FETCHED";
})(ComponentFetchedState || (exports.ComponentFetchedState = ComponentFetchedState = {}));
/** An enumeration representing the language a custom component is written in. */
var ComponentMarkupLanguage;
(function (ComponentMarkupLanguage) {
    /** The content of the component is a freemarker template. */
    ComponentMarkupLanguage["Freemarker"] = "FREEMARKER";
    /** The content of the component is a Handlebars template. */
    ComponentMarkupLanguage["Handlebars"] = "HANDLEBARS";
    /** The content of the component is static HTML. */
    ComponentMarkupLanguage["Html"] = "HTML";
    /** The content of the component is a javascript template. */
    ComponentMarkupLanguage["Javascript"] = "JAVASCRIPT";
    /** The content of the component is a react component. */
    ComponentMarkupLanguage["React"] = "REACT";
})(ComponentMarkupLanguage || (exports.ComponentMarkupLanguage = ComponentMarkupLanguage = {}));
/** Community pages a component can be scoped to. */
var ComponentPageScope;
(function (ComponentPageScope) {
    /** Blog board page. */
    ComponentPageScope["BlogBoard"] = "BLOG_BOARD";
    /** Blog message page. */
    ComponentPageScope["BlogMessage"] = "BLOG_MESSAGE";
    /** Category page. */
    ComponentPageScope["Category"] = "CATEGORY";
    /** Community page. */
    ComponentPageScope["Community"] = "COMMUNITY";
    /** Forum board page. */
    ComponentPageScope["ForumBoard"] = "FORUM_BOARD";
    /** Forum message page. */
    ComponentPageScope["ForumMessage"] = "FORUM_MESSAGE";
    /** Grouphub page. */
    ComponentPageScope["Grouphub"] = "GROUPHUB";
    /** Knowledge Base (KB) board page. */
    ComponentPageScope["TkbBoard"] = "TKB_BOARD";
    /** Knowledge Base (KB) message page. */
    ComponentPageScope["TkbMessage"] = "TKB_MESSAGE";
    /** User page. */
    ComponentPageScope["User"] = "USER";
})(ComponentPageScope || (exports.ComponentPageScope = ComponentPageScope = {}));
var ConditionName;
(function (ConditionName) {
    ConditionName["EmailDomain"] = "EMAIL_DOMAIN";
    ConditionName["Node"] = "NODE";
    ConditionName["Role"] = "ROLE";
})(ConditionName || (exports.ConditionName = ConditionName = {}));
/** Defines an enum for the content borders. */
var ContentBorder;
(function (ContentBorder) {
    ContentBorder["Dark"] = "DARK";
    ContentBorder["Light"] = "LIGHT";
    ContentBorder["None"] = "NONE";
})(ContentBorder || (exports.ContentBorder = ContentBorder = {}));
var ContentMetricDrillDownByType;
(function (ContentMetricDrillDownByType) {
    /** Content metric drill down by board */
    ContentMetricDrillDownByType["Board"] = "BOARD";
    /** Content metric drill down by topics */
    ContentMetricDrillDownByType["Topic"] = "TOPIC";
})(ContentMetricDrillDownByType || (exports.ContentMetricDrillDownByType = ContentMetricDrillDownByType = {}));
/** Specifies type of guide content type. */
var ContentType;
(function (ContentType) {
    /** Article content type. */
    ContentType["Article"] = "ARTICLE";
    /** Chapter content type. */
    ContentType["Chapter"] = "CHAPTER";
})(ContentType || (exports.ContentType = ContentType = {}));
/** An enumeration representing the state of an article in various stages of the workflow. */
var ContentWorkflowState;
(function (ContentWorkflowState) {
    /** State of an article in accepted. */
    ContentWorkflowState["Accepted"] = "ACCEPTED";
    /** State of an article in draft. */
    ContentWorkflowState["Draft"] = "DRAFT";
    /** State of an article in draft. */
    ContentWorkflowState["Initial"] = "INITIAL";
    /** State of an article in approval. */
    ContentWorkflowState["InApproval"] = "IN_APPROVAL";
    /** State of an article in review. */
    ContentWorkflowState["InReview"] = "IN_REVIEW";
    /** State of an article in nominated. */
    ContentWorkflowState["Nominated"] = "NOMINATED";
    /** State of an article in publish. */
    ContentWorkflowState["Publish"] = "PUBLISH";
    /** State of an article in rejected. */
    ContentWorkflowState["Rejected"] = "REJECTED";
    /** State of an article when scheduled for publish. */
    ContentWorkflowState["ScheduledForPublish"] = "SCHEDULED_FOR_PUBLISH";
})(ContentWorkflowState || (exports.ContentWorkflowState = ContentWorkflowState = {}));
/** An enumeration representing the method of contribution */
var ContributionMethod;
(function (ContributionMethod) {
    /** Used for explicitly adding a user as contributor or coauthor */
    ContributionMethod["ExplicitAdd"] = "EXPLICIT_ADD";
    /** Used for explicitly removing a user as contributor or coauthor */
    ContributionMethod["ExplicitRemove"] = "EXPLICIT_REMOVE";
})(ContributionMethod || (exports.ContributionMethod = ContributionMethod = {}));
/** An enumeration representing the relation of contributor to an article. */
var ContributorRelation;
(function (ContributorRelation) {
    /** CoAuthor of the Message */
    ContributorRelation["Coauthor"] = "COAUTHOR";
    /** Contributor of the Message */
    ContributorRelation["Contributor"] = "CONTRIBUTOR";
})(ContributorRelation || (exports.ContributorRelation = ContributorRelation = {}));
/** An enumeration that defines what conversation styles a given node contains. */
var ConversationStyle;
(function (ConversationStyle) {
    /** The conversation style is Blog. */
    ConversationStyle["Blog"] = "BLOG";
    /** The conversation style is Contest. */
    ConversationStyle["Contest"] = "CONTEST";
    /** The conversation style is Forum. */
    ConversationStyle["Forum"] = "FORUM";
    /** The conversation style is Group. */
    ConversationStyle["Group"] = "GROUP";
    /** The conversation style is Idea. */
    ConversationStyle["Idea"] = "IDEA";
    /** The conversation style is Occasion. */
    ConversationStyle["Occasion"] = "OCCASION";
    /** The conversation style is QandA. */
    ConversationStyle["Qanda"] = "QANDA";
    /** The conversation style is Tkb. */
    ConversationStyle["Tkb"] = "TKB";
})(ConversationStyle || (exports.ConversationStyle = ConversationStyle = {}));
/** An enumeration representing the type of cover image view style. */
var CoverImageStyle;
(function (CoverImageStyle) {
    /** The cover image style to be standard. */
    CoverImageStyle["Standard"] = "STANDARD";
    /** The cover image style to be wide. */
    CoverImageStyle["Wide"] = "WIDE";
})(CoverImageStyle || (exports.CoverImageStyle = CoverImageStyle = {}));
/** An enumeration representing the type of cover image title position. */
var CoverImageTitlePosition;
(function (CoverImageTitlePosition) {
    /** The title position to be bottom with respect to cover image. */
    CoverImageTitlePosition["Bottom"] = "BOTTOM";
    /** The title position to be overlay with respect to the cover image. */
    CoverImageTitlePosition["Overlay"] = "OVERLAY";
    /** The title position to be top with respect to the cover image. */
    CoverImageTitlePosition["Top"] = "TOP";
})(CoverImageTitlePosition || (exports.CoverImageTitlePosition = CoverImageTitlePosition = {}));
/**
 * Enumerates what type of access to the custom field Entity a caller must have
 * to perform an action (reading, writing, etc.) on a custom field.
 */
var CustomFieldAccessType;
(function (CustomFieldAccessType) {
    /** The caller must be able to administer the Entity the custom field is set on. */
    CustomFieldAccessType["Administrator"] = "ADMINISTRATOR";
    /**
     * Only the user who is the primary user for the entity, or an administrator, can take the action on the field.
     * If the entity is a User, the primary user would be that user. Also, if the entity is a User,
     * other non-admin users may be able to see the field if that user has granted access to them based on
     * their privacy settings.
     * If the entity is a Message, the primary user should be the author of that message, or someone who can edit that message.
     * If the entity is a Core Node, the primary user must be able to administer that core node.
     */
    CustomFieldAccessType["Private"] = "PRIVATE";
    /** Anyone can take the action on the field. This is the default if another value is not set for a action. */
    CustomFieldAccessType["Public"] = "PUBLIC";
    /** Only Registered users can take the action on the field. */
    CustomFieldAccessType["Registered"] = "REGISTERED";
})(CustomFieldAccessType || (exports.CustomFieldAccessType = CustomFieldAccessType = {}));
/** Enumerates sets of allowed characters a custom field can contain. */
var CustomFieldAllowedCharacterSet;
(function (CustomFieldAllowedCharacterSet) {
    /** Unicode Alpha-numeric characters only. */
    CustomFieldAllowedCharacterSet["AlphaNumeric"] = "ALPHA_NUMERIC";
    /** Alpha-numeric characters, or special characters: $-_.+!*'() */
    CustomFieldAllowedCharacterSet["AlphaNumericSpecialCharacters"] = "ALPHA_NUMERIC_SPECIAL_CHARACTERS";
    /** Alpha-numeric characters, or whitespace. */
    CustomFieldAllowedCharacterSet["AlphaNumericWhitespace"] = "ALPHA_NUMERIC_WHITESPACE";
    /** Alpha-numeric characters, whitespace, or special characterss. */
    CustomFieldAllowedCharacterSet["AlphaNumericWhitespaceSpecialCharacters"] = "ALPHA_NUMERIC_WHITESPACE_SPECIAL_CHARACTERS";
    /** The string can contain any character. Use with caution. */
    CustomFieldAllowedCharacterSet["Anything"] = "ANYTHING";
    /** The string can contain a set of HTML tags and attributes, determined by the permissions the caller has. */
    CustomFieldAllowedCharacterSet["Html"] = "HTML";
    /** A well-formed JSON string. */
    CustomFieldAllowedCharacterSet["Json"] = "JSON";
})(CustomFieldAllowedCharacterSet || (exports.CustomFieldAllowedCharacterSet = CustomFieldAllowedCharacterSet = {}));
/** Defines the value type of a custom field. */
var CustomFieldValueType;
(function (CustomFieldValueType) {
    /** A Boolean value type. */
    CustomFieldValueType["Boolean"] = "BOOLEAN";
    /** A DateTime value type. */
    CustomFieldValueType["Datetime"] = "DATETIME";
    /** A Float value type. */
    CustomFieldValueType["Float"] = "FLOAT";
    /** An Int value type. */
    CustomFieldValueType["Int"] = "INT";
    /** A list of Floats value type. */
    CustomFieldValueType["ListFloat"] = "LIST_FLOAT";
    /** A list of Ints value type. */
    CustomFieldValueType["ListInt"] = "LIST_INT";
    /** A list of Strings value type. */
    CustomFieldValueType["ListString"] = "LIST_STRING";
    /** A Long value type. */
    CustomFieldValueType["Long"] = "LONG";
    /** A String value type. */
    CustomFieldValueType["String"] = "STRING";
})(CustomFieldValueType || (exports.CustomFieldValueType = CustomFieldValueType = {}));
/** Enum used to specify whether to include custom quilts or not (or only return the custom quilts). */
var CustomQuiltReturnType;
(function (CustomQuiltReturnType) {
    /** Only return the custom quilts. */
    CustomQuiltReturnType["CustomOnly"] = "CUSTOM_ONLY";
    /** Include the custom quilts. */
    CustomQuiltReturnType["IncludeCustom"] = "INCLUDE_CUSTOM";
    /** Return no custom quilts. */
    CustomQuiltReturnType["NoCustom"] = "NO_CUSTOM";
})(CustomQuiltReturnType || (exports.CustomQuiltReturnType = CustomQuiltReturnType = {}));
/** Specifies what a scoped asset is scoped to. */
var CustomizationPointScopeType;
(function (CustomizationPointScopeType) {
    /** Scoped to a core node. */
    CustomizationPointScopeType["Node"] = "NODE";
    /** Scoped to a page. */
    CustomizationPointScopeType["Page"] = "PAGE";
    /** Scoped to a quilt. */
    CustomizationPointScopeType["Quilt"] = "QUILT";
})(CustomizationPointScopeType || (exports.CustomizationPointScopeType = CustomizationPointScopeType = {}));
/** Specifies the type of asset being scoped. */
var CustomizationPointType;
(function (CustomizationPointType) {
    CustomizationPointType["Quilt"] = "QUILT";
    CustomizationPointType["Theme"] = "THEME";
})(CustomizationPointType || (exports.CustomizationPointType = CustomizationPointType = {}));
var DateTimeCustomFormFieldType;
(function (DateTimeCustomFormFieldType) {
    /** A datetime field. */
    DateTimeCustomFormFieldType["Datetime"] = "DATETIME";
    /** An input field. */
    DateTimeCustomFormFieldType["Input"] = "INPUT";
})(DateTimeCustomFormFieldType || (exports.DateTimeCustomFormFieldType = DateTimeCustomFormFieldType = {}));
/** Defines a unit of time to use for dates. */
var DateUnit;
(function (DateUnit) {
    /** The unit of time is a day. */
    DateUnit["Day"] = "DAY";
    /** The unit of time is a month. */
    DateUnit["Month"] = "MONTH";
    /** The unit of time is a year. */
    DateUnit["Year"] = "YEAR";
})(DateUnit || (exports.DateUnit = DateUnit = {}));
/** Member delete status enum. */
var DeleteStatus;
(function (DeleteStatus) {
    DeleteStatus["Deleted"] = "DELETED";
    DeleteStatus["NotDeleted"] = "NOT_DELETED";
})(DeleteStatus || (exports.DeleteStatus = DeleteStatus = {}));
/** Defines delivery day of the week */
var DeliveryDay;
(function (DeliveryDay) {
    DeliveryDay["Friday"] = "FRIDAY";
    DeliveryDay["Monday"] = "MONDAY";
    DeliveryDay["Saturday"] = "SATURDAY";
    DeliveryDay["Sunday"] = "SUNDAY";
    DeliveryDay["Thursday"] = "THURSDAY";
    DeliveryDay["Tuesday"] = "TUESDAY";
    DeliveryDay["Wednesday"] = "WEDNESDAY";
})(DeliveryDay || (exports.DeliveryDay = DeliveryDay = {}));
/** Disable spacing enum. */
var DisableSpacing;
(function (DisableSpacing) {
    DisableSpacing["Both"] = "BOTH";
    DisableSpacing["Bottom"] = "BOTTOM";
    DisableSpacing["Top"] = "TOP";
})(DisableSpacing || (exports.DisableSpacing = DisableSpacing = {}));
/** Defines enum for traffic metrics drill down eligible metrics */
var DrillDownContentMetricEnum;
(function (DrillDownContentMetricEnum) {
    /** Number of blog posts. */
    DrillDownContentMetricEnum["BlogPosts"] = "BLOG_POSTS";
    /** Number of forum topics. */
    DrillDownContentMetricEnum["ForumDiscussions"] = "FORUM_DISCUSSIONS";
    /** IDEAS Submitted */
    DrillDownContentMetricEnum["IdeasSubmitted"] = "IDEAS_SUBMITTED";
    /** Number of Idea votes */
    DrillDownContentMetricEnum["IdeaVotes"] = "IDEA_VOTES";
    /** Likes Given */
    DrillDownContentMetricEnum["KudosGiven"] = "KUDOS_GIVEN";
    /** Number of replies. */
    DrillDownContentMetricEnum["Replies"] = "REPLIES";
    /** Number of TKB articles. */
    DrillDownContentMetricEnum["TkbArticles"] = "TKB_ARTICLES";
})(DrillDownContentMetricEnum || (exports.DrillDownContentMetricEnum = DrillDownContentMetricEnum = {}));
/** Defines enum for traffic metrics drill down eligible metrics */
var DrillDownTrafficMetricEnum;
(function (DrillDownTrafficMetricEnum) {
    /** Fetches visits by user type - anonymous. */
    DrillDownTrafficMetricEnum["AnonymousVisits"] = "ANONYMOUS_VISITS";
    /** Fetches visits by user type - members. */
    DrillDownTrafficMetricEnum["MembersVisits"] = "MEMBERS_VISITS";
    /**
     * A page view is counted each time a browser requests a page, regardless of the device type or whether the page is
     * cached. Page Views approximates user behavior and therefore excludes non-human requests (Web crawlers,
     * robots, RSS feeds, REST API calls, ActiveCast calls, and LevelUp requests).
     */
    DrillDownTrafficMetricEnum["PageViews"] = "PAGE_VIEWS";
    /** Number of unique visitors. */
    DrillDownTrafficMetricEnum["UniqueVisitors"] = "UNIQUE_VISITORS";
    /** Number of visits. */
    DrillDownTrafficMetricEnum["Visits"] = "VISITS";
})(DrillDownTrafficMetricEnum || (exports.DrillDownTrafficMetricEnum = DrillDownTrafficMetricEnum = {}));
/** The type of HTTP Request Body that the endpoint expects. */
var EndpointBodyType;
(function (EndpointBodyType) {
    /** The endpoint expects a JSON body. */
    EndpointBodyType["Json"] = "JSON";
    /** The endpoint expects a multipart body with only fields (no files). */
    EndpointBodyType["Multipart"] = "MULTIPART";
    /** The endpoint expects a multipart body with files. */
    EndpointBodyType["MultipartFiles"] = "MULTIPART_FILES";
    /** The endpoint does not expect a body. */
    EndpointBodyType["None"] = "NONE";
    /** The endpoint expects a URL encoded body. */
    EndpointBodyType["UrlEncoded"] = "URL_ENCODED";
})(EndpointBodyType || (exports.EndpointBodyType = EndpointBodyType = {}));
/** Enumeration that specifies a group to cache an endpoint call response for. */
var EndpointCachingFor;
(function (EndpointCachingFor) {
    /** Cache the response for the anonymous user only. */
    EndpointCachingFor["AnonymousUser"] = "ANONYMOUS_USER";
    /**
     * Cache the response for the currently signed in user.
     * Only caches if a registered user is authenticated to the endpoint when it is called.
     */
    EndpointCachingFor["CurrentRegisteredUser"] = "CURRENT_REGISTERED_USER";
    /** Cache the response for the current user, regardless of whether or not it's a signed in or the anonymous user. */
    EndpointCachingFor["CurrentUser"] = "CURRENT_USER";
    /** Cache Globally (for everyone). */
    EndpointCachingFor["Global"] = "GLOBAL";
})(EndpointCachingFor || (exports.EndpointCachingFor = EndpointCachingFor = {}));
/** The type of HTTP Request Method that the endpoint expects. */
var EndpointHttpMethod;
(function (EndpointHttpMethod) {
    /** The endpoint expects a DELETE request. */
    EndpointHttpMethod["Delete"] = "DELETE";
    /** The endpoint expects a GET request. */
    EndpointHttpMethod["Get"] = "GET";
    /** The endpoint expects a HEAD request. */
    EndpointHttpMethod["Head"] = "HEAD";
    /** The endpoint expects an OPTIONS request. */
    EndpointHttpMethod["Options"] = "OPTIONS";
    /** The endpoint expects a PATCH request. */
    EndpointHttpMethod["Patch"] = "PATCH";
    /** The endpoint expects a POST request. */
    EndpointHttpMethod["Post"] = "POST";
    /** The endpoint expects a PUT request. */
    EndpointHttpMethod["Put"] = "PUT";
})(EndpointHttpMethod || (exports.EndpointHttpMethod = EndpointHttpMethod = {}));
/** Enumerates what action a form field for mutating an Entity is for. */
var EntityFormAction;
(function (EntityFormAction) {
    /** The form is for creating a new Entity. */
    EntityFormAction["Create"] = "CREATE";
    /** The form is for updating an existing Entity. */
    EntityFormAction["Update"] = "UPDATE";
})(EntityFormAction || (exports.EntityFormAction = EntityFormAction = {}));
/** Specifies the type of an Entity. */
var EntityType;
(function (EntityType) {
    /** The Blog entity. */
    EntityType["Blog"] = "BLOG";
    /** The Blog Article entity. */
    EntityType["BlogArticle"] = "BLOG_ARTICLE";
    /** The Blog Reply entity. */
    EntityType["BlogReply"] = "BLOG_REPLY";
    /** Case details entity. */
    EntityType["CaseDetails"] = "CASE_DETAILS";
    /** Case portal entity. */
    EntityType["CasePortal"] = "CASE_PORTAL";
    /** The Category entity. */
    EntityType["Category"] = "CATEGORY";
    /** The Community entity. */
    EntityType["Community"] = "COMMUNITY";
    /** The Custom entity. */
    EntityType["Custom"] = "CUSTOM";
    /** The Event entity. */
    EntityType["Event"] = "EVENT";
    /** An Event Reply entity. */
    EntityType["EventReply"] = "EVENT_REPLY";
    /** An Event Topic entity. */
    EntityType["EventTopic"] = "EVENT_TOPIC";
    /** The Forum entity. */
    EntityType["Forum"] = "FORUM";
    /** The Forum Reply entity. */
    EntityType["ForumReply"] = "FORUM_REPLY";
    /** The Forum Topic entity. */
    EntityType["ForumTopic"] = "FORUM_TOPIC";
    /** The GroupHub entity. */
    EntityType["GroupHub"] = "GROUP_HUB";
    /** The Idea entity. */
    EntityType["Idea"] = "IDEA";
    /** The Idea Post entity. */
    EntityType["IdeaPost"] = "IDEA_POST";
    /** The Idea Reply entity. */
    EntityType["IdeaReply"] = "IDEA_REPLY";
    /** Occasion entity. */
    EntityType["Occasion"] = "OCCASION";
    /** Occasion reply entity. */
    EntityType["OccasionReply"] = "OCCASION_REPLY";
    /** Occasion topic entity. */
    EntityType["OccasionTopic"] = "OCCASION_TOPIC";
    /** The Q&A entity. */
    EntityType["Qanda"] = "QANDA";
    /** The Q&A Answer entity. */
    EntityType["QandaAnswer"] = "QANDA_ANSWER";
    /** The Q&A Question entity. */
    EntityType["QandaQuestion"] = "QANDA_QUESTION";
    /** Salesforce case entity */
    EntityType["SalesforceCase"] = "SALESFORCE_CASE";
    /** Salesforce case creation entity */
    EntityType["SalesforceCaseCreation"] = "SALESFORCE_CASE_CREATION";
    /** The Tkb entity. */
    EntityType["Tkb"] = "TKB";
    /** The Tkb Article entity. */
    EntityType["TkbArticle"] = "TKB_ARTICLE";
    /** The Tkb Reply entity. */
    EntityType["TkbReply"] = "TKB_REPLY";
    /** The User entity. */
    EntityType["User"] = "USER";
})(EntityType || (exports.EntityType = EntityType = {}));
/** pre-set intervals to re-fetch HTML custom component content after. */
var FetchedContentInterval;
(function (FetchedContentInterval) {
    /** Custom: use the customIntervalMinutes to set the number. */
    FetchedContentInterval["Custom"] = "CUSTOM";
    /** 1 Day */
    FetchedContentInterval["OneDay"] = "ONE_DAY";
    /** 1 Hour */
    FetchedContentInterval["OneHour"] = "ONE_HOUR";
    /** 1 Month */
    FetchedContentInterval["OneMonth"] = "ONE_MONTH";
    /** 1 Week */
    FetchedContentInterval["OneWeek"] = "ONE_WEEK";
    /** 6 Hours */
    FetchedContentInterval["SixHours"] = "SIX_HOURS";
    /** 30 Minutes */
    FetchedContentInterval["ThirtyMinutes"] = "THIRTY_MINUTES";
    /** 12 Hours */
    FetchedContentInterval["TwelveHours"] = "TWELVE_HOURS";
    /** 2 Hours */
    FetchedContentInterval["TwoHours"] = "TWO_HOURS";
})(FetchedContentInterval || (exports.FetchedContentInterval = FetchedContentInterval = {}));
/** Defines the data type of a field. */
var FieldDataType;
(function (FieldDataType) {
    /** A boolean data type. */
    FieldDataType["Boolean"] = "BOOLEAN";
    /** A number data type. */
    FieldDataType["Number"] = "NUMBER";
    /** A string data type. */
    FieldDataType["String"] = "STRING";
})(FieldDataType || (exports.FieldDataType = FieldDataType = {}));
/** Defines a control to use for inputting the value of a field. */
var FieldInputControl;
(function (FieldInputControl) {
    /** A check box. */
    FieldInputControl["Check"] = "CHECK";
    /** A datetime input. */
    FieldInputControl["Datetime"] = "DATETIME";
    /** An input box. */
    FieldInputControl["Input"] = "INPUT";
    /** A radio button. */
    FieldInputControl["Radio"] = "RADIO";
    /** A select box. */
    FieldInputControl["Select"] = "SELECT";
})(FieldInputControl || (exports.FieldInputControl = FieldInputControl = {}));
/** Enumerates the requirement rules for setting a field. */
var FieldSettableForAction;
(function (FieldSettableForAction) {
    /** The field is not settable during the given action. */
    FieldSettableForAction["No"] = "NO";
    /** The field is required to be set during the given action. */
    FieldSettableForAction["Required"] = "REQUIRED";
    /** The field is settable during the given action, but not required to be set. */
    FieldSettableForAction["Yes"] = "YES";
})(FieldSettableForAction || (exports.FieldSettableForAction = FieldSettableForAction = {}));
var FieldType;
(function (FieldType) {
    FieldType["Check"] = "CHECK";
    FieldType["Input"] = "INPUT";
    FieldType["Password"] = "PASSWORD";
    FieldType["Radio"] = "RADIO";
    FieldType["Range"] = "RANGE";
    FieldType["Rte"] = "RTE";
    FieldType["Select"] = "SELECT";
    FieldType["TextArea"] = "TEXT_AREA";
})(FieldType || (exports.FieldType = FieldType = {}));
/** An enumeration representing the type of action a content filter needs to take when a matching term is found. */
var FilterAction;
(function (FilterAction) {
    /** Deny the user from posting when a matching term is found. */
    FilterAction["Deny"] = "DENY";
    /** Deny the user from posting, but ignore inline HTML when a matching term is found. */
    FilterAction["Denystr"] = "DENYSTR";
    /** Assign a minimum grade when a matching term is present. */
    FilterAction["Grade"] = "GRADE";
    /** Take no action when a matching term is found. */
    FilterAction["Off"] = "OFF";
    /** Replace the matching term with a replacement word ('**bleep**' is the default replacement word). */
    FilterAction["Replace"] = "REPLACE";
})(FilterAction || (exports.FilterAction = FilterAction = {}));
/** An enum input type to filter based on event entity types */
var FilterEventEntityEnum;
(function (FilterEventEntityEnum) {
    /** Blog entity type */
    FilterEventEntityEnum["Blog"] = "BLOG";
    /** Forum entity type */
    FilterEventEntityEnum["Forum"] = "FORUM";
    /** Idea entity type */
    FilterEventEntityEnum["Idea"] = "IDEA";
    /** Note entity type */
    FilterEventEntityEnum["Notes"] = "NOTES";
    /** Occasion entity type */
    FilterEventEntityEnum["Occasion"] = "OCCASION";
    /** Qanda entity type */
    FilterEventEntityEnum["Qanda"] = "QANDA";
    /** Tkb entity type */
    FilterEventEntityEnum["Tkb"] = "TKB";
    /** User entity type */
    FilterEventEntityEnum["User"] = "USER";
})(FilterEventEntityEnum || (exports.FilterEventEntityEnum = FilterEventEntityEnum = {}));
/** Filter operator types: equals or not_equals. */
var FilterOperator;
(function (FilterOperator) {
    /** Equals to. */
    FilterOperator["Eq"] = "EQ";
    /** Not equals to. */
    FilterOperator["Neq"] = "NEQ";
})(FilterOperator || (exports.FilterOperator = FilterOperator = {}));
/** An enumeration representing the entities in community to which a content filter can be applied. */
var FilteredEntityType;
(function (FilteredEntityType) {
    /** A caption. */
    FilteredEntityType["Captions"] = "CAPTIONS";
    /** User login. */
    FilteredEntityType["Login"] = "LOGIN";
    /** Media. */
    FilteredEntityType["Media"] = "MEDIA";
    /** A message. */
    FilteredEntityType["Message"] = "MESSAGE";
    /** A private message. */
    FilteredEntityType["Notes"] = "NOTES";
    /** A tag. */
    FilteredEntityType["Tag"] = "TAG";
    /** A user. */
    FilteredEntityType["User"] = "USER";
})(FilteredEntityType || (exports.FilteredEntityType = FilteredEntityType = {}));
/** Enumerates the types of float form fields. */
var FloatCustomFormFieldType;
(function (FloatCustomFormFieldType) {
    /** An input field. */
    FloatCustomFormFieldType["Input"] = "INPUT";
    /** A radio field. */
    FloatCustomFormFieldType["Radio"] = "RADIO";
    /** A range field. */
    FloatCustomFormFieldType["Range"] = "RANGE";
    /** A select field. */
    FloatCustomFormFieldType["Select"] = "SELECT";
})(FloatCustomFormFieldType || (exports.FloatCustomFormFieldType = FloatCustomFormFieldType = {}));
/** Enumerates the types of list float form fields. */
var FloatListCustomFormFieldType;
(function (FloatListCustomFormFieldType) {
    /** A select field. */
    FloatListCustomFormFieldType["Select"] = "SELECT";
})(FloatListCustomFormFieldType || (exports.FloatListCustomFormFieldType = FloatListCustomFormFieldType = {}));
/** Defines an enum for the font source. */
var FontSource;
(function (FontSource) {
    FontSource["Adobe"] = "ADOBE";
    FontSource["Google"] = "GOOGLE";
    FontSource["Local"] = "LOCAL";
    FontSource["Server"] = "SERVER";
})(FontSource || (exports.FontSource = FontSource = {}));
/** Defines an enum for the font styles. */
var FontStyle;
(function (FontStyle) {
    FontStyle["Italic"] = "ITALIC";
    FontStyle["Normal"] = "NORMAL";
})(FontStyle || (exports.FontStyle = FontStyle = {}));
var FormActionButtonBarPosition;
(function (FormActionButtonBarPosition) {
    /** Action buttons are sticky at the bottom. */
    FormActionButtonBarPosition["Sticky"] = "sticky";
})(FormActionButtonBarPosition || (exports.FormActionButtonBarPosition = FormActionButtonBarPosition = {}));
/** Action buttons position for a form. */
var FormActionButtonsPosition;
(function (FormActionButtonsPosition) {
    /** Positioned in the center. */
    FormActionButtonsPosition["Center"] = "center";
    /** Positioned to the left. */
    FormActionButtonsPosition["Left"] = "left";
    /** Positioned to the right. */
    FormActionButtonsPosition["Right"] = "right";
})(FormActionButtonsPosition || (exports.FormActionButtonsPosition = FormActionButtonsPosition = {}));
var FormGroupFieldSeparator;
(function (FormGroupFieldSeparator) {
    FormGroupFieldSeparator["Divider"] = "divider";
})(FormGroupFieldSeparator || (exports.FormGroupFieldSeparator = FormGroupFieldSeparator = {}));
/** Type of input to use for an input field. */
var FormInputType;
(function (FormInputType) {
    FormInputType["Hidden"] = "HIDDEN";
    FormInputType["Text"] = "TEXT";
})(FormInputType || (exports.FormInputType = FormInputType = {}));
/** Defines enum for all applicable sort metrics for forumBoardReport. */
var ForumBoardReportSortMetric;
(function (ForumBoardReportSortMetric) {
    /** Number of the forum topics. */
    ForumBoardReportSortMetric["DiscussionsPublished"] = "DISCUSSIONS_PUBLISHED";
    /** Number of the first replies to all forum topics. */
    ForumBoardReportSortMetric["FirstReplies"] = "FIRST_REPLIES";
    /** Average time to get the first reply on forum topics. */
    ForumBoardReportSortMetric["FirstReplyAvgTime"] = "FIRST_REPLY_AVG_TIME";
    /** Average time to get the first solution on forum topics. */
    ForumBoardReportSortMetric["FirstSolutionAvgTime"] = "FIRST_SOLUTION_AVG_TIME";
    /** Likes given. */
    ForumBoardReportSortMetric["KudosGiven"] = "KUDOS_GIVEN";
    /** Number of subscriptions made on nodes. */
    ForumBoardReportSortMetric["NodeSubscriptions"] = "NODE_SUBSCRIPTIONS";
    /**
     * A page view is counted each time a browser requests a page, regardless of the device type or whether the page is
     * cached. Page views approximates user behavior and therefore excludes non-human requests (Web crawlers,
     * robots, RSS feeds, REST API calls, ActiveCast calls, and LevelUp requests).
     */
    ForumBoardReportSortMetric["PageViews"] = "PAGE_VIEWS";
    /** Number of subscriptions made on posts. */
    ForumBoardReportSortMetric["PostSubscriptions"] = "POST_SUBSCRIPTIONS";
    /** Number of the forum replies. */
    ForumBoardReportSortMetric["RepliesPublished"] = "REPLIES_PUBLISHED";
    /** Number of replies accepted as solution to the parent topic. */
    ForumBoardReportSortMetric["SolutionsAccepted"] = "SOLUTIONS_ACCEPTED";
    /** Number of replies viewed as solution to the parent topic. */
    ForumBoardReportSortMetric["SolutionsViews"] = "SOLUTIONS_VIEWS";
    /** Unique number of visitors. */
    ForumBoardReportSortMetric["UniqueVisitors"] = "UNIQUE_VISITORS";
    /** A visit is one or more page views over time by a uniquely identified client (visitor). */
    ForumBoardReportSortMetric["Visits"] = "VISITS";
})(ForumBoardReportSortMetric || (exports.ForumBoardReportSortMetric = ForumBoardReportSortMetric = {}));
/** Defines enum for all applicable sort metrics for forumDiscussionsReport. */
var ForumDiscussionsReportSortMetric;
(function (ForumDiscussionsReportSortMetric) {
    /** Average time to get the first reply on forum topics. */
    ForumDiscussionsReportSortMetric["FirstReplyAvgTime"] = "FIRST_REPLY_AVG_TIME";
    /** Average time to get the first solution on forum topics. */
    ForumDiscussionsReportSortMetric["FirstSolutionAvgTime"] = "FIRST_SOLUTION_AVG_TIME";
    /** Likes given. */
    ForumDiscussionsReportSortMetric["KudosGiven"] = "KUDOS_GIVEN";
    /**
     * A page view is counted each time a browser requests a page, regardless of the device type or whether the page is
     * cached. Page views approximates user behavior and therefore excludes non-human requests (Web crawlers,
     * robots, RSS feeds, REST API calls, ActiveCast calls, and LevelUp requests).
     */
    ForumDiscussionsReportSortMetric["PageViews"] = "PAGE_VIEWS";
    /** Number of subscriptions made on posts. */
    ForumDiscussionsReportSortMetric["PostSubscriptions"] = "POST_SUBSCRIPTIONS";
    /** Number of the forum replies. */
    ForumDiscussionsReportSortMetric["RepliesPublished"] = "REPLIES_PUBLISHED";
    /** Number of replies accepted as solution to the parent topic. */
    ForumDiscussionsReportSortMetric["SolutionsAccepted"] = "SOLUTIONS_ACCEPTED";
    /** Number of replies viewed as solution to the parent topic. */
    ForumDiscussionsReportSortMetric["SolutionsViews"] = "SOLUTIONS_VIEWS";
    /** Unique number of visitors. */
    ForumDiscussionsReportSortMetric["UniqueVisitors"] = "UNIQUE_VISITORS";
    /** A visit is one or more page views over time by a uniquely identified client (visitor). */
    ForumDiscussionsReportSortMetric["Visits"] = "VISITS";
})(ForumDiscussionsReportSortMetric || (exports.ForumDiscussionsReportSortMetric = ForumDiscussionsReportSortMetric = {}));
/** An enumeration that defines what conversation styles a given grouphub contains. */
var GroupHubConversationStyle;
(function (GroupHubConversationStyle) {
    /** The conversation style is Blog. */
    GroupHubConversationStyle["Blog"] = "BLOG";
    /** The conversation style is Contest. */
    GroupHubConversationStyle["Contest"] = "CONTEST";
    /** The conversation style is Forum. */
    GroupHubConversationStyle["Forum"] = "FORUM";
    /** The conversation style is Idea. */
    GroupHubConversationStyle["Idea"] = "IDEA";
    /** The conversation style is Occasion. */
    GroupHubConversationStyle["Occasion"] = "OCCASION";
    /** The conversation style is QandA. */
    GroupHubConversationStyle["Qanda"] = "QANDA";
    /** The conversation style is Tkb. */
    GroupHubConversationStyle["Tkb"] = "TKB";
})(GroupHubConversationStyle || (exports.GroupHubConversationStyle = GroupHubConversationStyle = {}));
/** Defines enum for all applicable sort metrics for groupHubReport. */
var GroupHubReportSortMetric;
(function (GroupHubReportSortMetric) {
    /** Number of the blog articles published. */
    GroupHubReportSortMetric["BlogPostsPublished"] = "BLOG_POSTS_PUBLISHED";
    /** Number of the forum topics. */
    GroupHubReportSortMetric["ForumDiscussionsPublished"] = "FORUM_DISCUSSIONS_PUBLISHED";
    /** Number of members who accepted the invite to grouphubs. */
    GroupHubReportSortMetric["GrouphubInvitesAccepted"] = "GROUPHUB_INVITES_ACCEPTED";
    /** Number of members to whom invites were sent for grouphubs. */
    GroupHubReportSortMetric["GrouphubInvitesSent"] = "GROUPHUB_INVITES_SENT";
    /** Number of members who joined grouphubs. */
    GroupHubReportSortMetric["GrouphubMembersJoined"] = "GROUPHUB_MEMBERS_JOINED";
    /** Number of members who left grouphubs. */
    GroupHubReportSortMetric["GrouphubMembersLeft"] = "GROUPHUB_MEMBERS_LEFT";
    /** Number of ideas submitted. */
    GroupHubReportSortMetric["IdeasSubmitted"] = "IDEAS_SUBMITTED";
    /** Number of idea votes. */
    GroupHubReportSortMetric["IdeaVotes"] = "IDEA_VOTES";
    /** Likes given. */
    GroupHubReportSortMetric["KudosGiven"] = "KUDOS_GIVEN";
    /** Number of subscriptions made on nodes. */
    GroupHubReportSortMetric["NodeSubscriptions"] = "NODE_SUBSCRIPTIONS";
    /** Number of occasion created. */
    GroupHubReportSortMetric["OccasionsCreated"] = "OCCASIONS_CREATED";
    /** Attendance of the occasion */
    GroupHubReportSortMetric["OccasionAttendance"] = "OCCASION_ATTENDANCE";
    /** Number of Occasion Attending RSVPs */
    GroupHubReportSortMetric["OccasionRsvpAttending"] = "OCCASION_RSVP_ATTENDING";
    /** Number of Occasion Interested RSVPs */
    GroupHubReportSortMetric["OccasionRsvpInterested"] = "OCCASION_RSVP_INTERESTED";
    /**
     * A page view is counted each time a browser requests a page, regardless of the device type or whether the page is
     * cached. Page views approximates user behavior and therefore excludes non-human requests (Web crawlers,
     * robots, RSS feeds, REST API calls, ActiveCast calls, and LevelUp requests).
     */
    GroupHubReportSortMetric["PageViews"] = "PAGE_VIEWS";
    /** Number of the KB articles posted. */
    GroupHubReportSortMetric["TkbArticlesPublished"] = "TKB_ARTICLES_PUBLISHED";
    /** Unique number of visitors. */
    GroupHubReportSortMetric["UniqueVisitors"] = "UNIQUE_VISITORS";
    /** A visit is one or more page views over time by a uniquely identified client (visitor). */
    GroupHubReportSortMetric["Visits"] = "VISITS";
})(GroupHubReportSortMetric || (exports.GroupHubReportSortMetric = GroupHubReportSortMetric = {}));
/** Groups a component can belong to. */
var Groups;
(function (Groups) {
    /** Content group. */
    Groups["Content"] = "CONTENT";
    /** Custome group */
    Groups["Custom"] = "CUSTOM";
    /** People group */
    Groups["People"] = "PEOPLE";
    /** PLaces group. */
    Groups["Places"] = "PLACES";
    /** Text/HTML group */
    Groups["Texthtml"] = "TEXTHTML";
})(Groups || (exports.Groups = Groups = {}));
var IdeaBoardReportSortMetric;
(function (IdeaBoardReportSortMetric) {
    /** Number of ideas closed */
    IdeaBoardReportSortMetric["IdeasClosed"] = "IDEAS_CLOSED";
    /** Number of ideas completed */
    IdeaBoardReportSortMetric["IdeasCompleted"] = "IDEAS_COMPLETED";
    /** Number of ideas submitted. */
    IdeaBoardReportSortMetric["IdeasSubmitted"] = "IDEAS_SUBMITTED";
    /** Votes given. */
    IdeaBoardReportSortMetric["IdeaVotes"] = "IDEA_VOTES";
    /** Number of subscriptions made on nodes. */
    IdeaBoardReportSortMetric["NodeSubscriptions"] = "NODE_SUBSCRIPTIONS";
    /**
     * A page view is counted each time a browser requests a page, regardless of the device type or whether the page is
     * cached. Page Views approximates user behavior and therefore excludes non-human requests (Web crawlers,
     * robots, RSS feeds, REST API calls, ActiveCast calls, and LevelUp requests).
     */
    IdeaBoardReportSortMetric["PageViews"] = "PAGE_VIEWS";
    /** Number of replies on Ideas */
    IdeaBoardReportSortMetric["Replies"] = "REPLIES";
    /** Unique number of visitors. */
    IdeaBoardReportSortMetric["UniqueVisitors"] = "UNIQUE_VISITORS";
    /** A visit is one or more page views over time by a uniquely identified client (visitor). */
    IdeaBoardReportSortMetric["Visits"] = "VISITS";
})(IdeaBoardReportSortMetric || (exports.IdeaBoardReportSortMetric = IdeaBoardReportSortMetric = {}));
/** An enumeration that defines the type of label for the idea status. */
var IdeaStatusLabelType;
(function (IdeaStatusLabelType) {
    /** Displays a filled label for the idea status. */
    IdeaStatusLabelType["Filled"] = "FILLED";
    /** Displays an outline for the idea status. */
    IdeaStatusLabelType["Outline"] = "OUTLINE";
    /** Displays only the text for the idea status. */
    IdeaStatusLabelType["Textonly"] = "TEXTONLY";
})(IdeaStatusLabelType || (exports.IdeaStatusLabelType = IdeaStatusLabelType = {}));
var IdeasReportSortMetric;
(function (IdeasReportSortMetric) {
    /** Number of ideas closed */
    IdeasReportSortMetric["IdeasClosed"] = "IDEAS_CLOSED";
    /** Number of ideas completed */
    IdeasReportSortMetric["IdeasCompleted"] = "IDEAS_COMPLETED";
    /** Votes given. */
    IdeasReportSortMetric["IdeaVotes"] = "IDEA_VOTES";
    /**
     * A page view is counted each time a browser requests a page, regardless of the device type or whether the page is
     * cached. Page Views approximates user behavior and therefore excludes non-human requests (Web crawlers,
     * robots, RSS feeds, REST API calls, ActiveCast calls, and LevelUp requests).
     */
    IdeasReportSortMetric["PageViews"] = "PAGE_VIEWS";
    /** Number of subscriptions made on articles. */
    IdeasReportSortMetric["PostSubscriptions"] = "POST_SUBSCRIPTIONS";
    /** Number of replies published */
    IdeasReportSortMetric["Replies"] = "REPLIES";
    /** Unique number of visitors. */
    IdeasReportSortMetric["UniqueVisitors"] = "UNIQUE_VISITORS";
    /** A visit is one or more page views over time by a uniquely identified client (visitor). */
    IdeasReportSortMetric["Visits"] = "VISITS";
})(IdeasReportSortMetric || (exports.IdeasReportSortMetric = IdeasReportSortMetric = {}));
var ImageAssociatedEntityType;
(function (ImageAssociatedEntityType) {
    ImageAssociatedEntityType["Badge"] = "BADGE";
    ImageAssociatedEntityType["Message"] = "MESSAGE";
    ImageAssociatedEntityType["Node"] = "NODE";
    ImageAssociatedEntityType["PrivateNote"] = "PRIVATE_NOTE";
    ImageAssociatedEntityType["Rank"] = "RANK";
    ImageAssociatedEntityType["Survey"] = "SURVEY";
    ImageAssociatedEntityType["User"] = "USER";
})(ImageAssociatedEntityType || (exports.ImageAssociatedEntityType = ImageAssociatedEntityType = {}));
var ImageAssociationType;
(function (ImageAssociationType) {
    /** The image association type is inline body. */
    ImageAssociationType["Body"] = "BODY";
    /** The image association type is cover image. */
    ImageAssociationType["Cover"] = "COVER";
    /** The image association type is quote block. */
    ImageAssociationType["Quote"] = "QUOTE";
    /** The image association type is inline teaser. */
    ImageAssociationType["Teaser"] = "TEASER";
})(ImageAssociationType || (exports.ImageAssociationType = ImageAssociationType = {}));
/** Enum that defines inherited access level for a permission. */
var InheritedAccess;
(function (InheritedAccess) {
    InheritedAccess["Assign"] = "ASSIGN";
    InheritedAccess["Denied"] = "DENIED";
    InheritedAccess["Granted"] = "GRANTED";
})(InheritedAccess || (exports.InheritedAccess = InheritedAccess = {}));
/** Enumerates the types of int form fields */
var IntCustomFormFieldType;
(function (IntCustomFormFieldType) {
    /** An input field. */
    IntCustomFormFieldType["Input"] = "INPUT";
    /** A radio field. */
    IntCustomFormFieldType["Radio"] = "RADIO";
    /** A range field. */
    IntCustomFormFieldType["Range"] = "RANGE";
    /** A select field. */
    IntCustomFormFieldType["Select"] = "SELECT";
})(IntCustomFormFieldType || (exports.IntCustomFormFieldType = IntCustomFormFieldType = {}));
/** Enumerates the types of list int form fields */
var IntListCustomFormFieldType;
(function (IntListCustomFormFieldType) {
    /** A select field. */
    IntListCustomFormFieldType["Select"] = "SELECT";
})(IntListCustomFormFieldType || (exports.IntListCustomFormFieldType = IntListCustomFormFieldType = {}));
/** Defines an enumeration for interaction statuses in private conversations. */
var InteractionStatus;
(function (InteractionStatus) {
    InteractionStatus["Muted"] = "MUTED";
    InteractionStatus["Unmuted"] = "UNMUTED";
})(InteractionStatus || (exports.InteractionStatus = InteractionStatus = {}));
/** Intervals granularities available in the API to fetch the chart data on. */
var Interval;
(function (Interval) {
    /** Bucketize the metric in buckets of eight hours. */
    Interval["EightHours"] = "EIGHT_HOURS";
    /** Bucketize the metric in buckets of fifteen minutes. */
    Interval["FifteenMinutes"] = "FIFTEEN_MINUTES";
    /** Bucketize the metric in buckets of five minutes. */
    Interval["FiveMinutes"] = "FIVE_MINUTES";
    /** Bucketize the metric in buckets of four hours. */
    Interval["FourHours"] = "FOUR_HOURS";
    /** Bucketize the metric in buckets of one day. */
    Interval["OneDay"] = "ONE_DAY";
    /** Bucketize the metric in buckets of one hour. */
    Interval["OneHour"] = "ONE_HOUR";
    /** Bucketize the metric in buckets of one month. */
    Interval["OneMonth"] = "ONE_MONTH";
    /** Bucketize the metric in buckets of seven days. */
    Interval["SevenDays"] = "SEVEN_DAYS";
    /** Bucketize the metric in buckets of ten minutes. */
    Interval["TenMinutes"] = "TEN_MINUTES";
    /** Bucketize the metric in buckets of thirty minutes. */
    Interval["ThirtyMinutes"] = "THIRTY_MINUTES";
    /** Bucketize the metric in buckets of three months. */
    Interval["ThreeMonths"] = "THREE_MONTHS";
    /** Bucketize the metric in buckets of twelve hours. */
    Interval["TwelveHours"] = "TWELVE_HOURS";
    /** Bucketize the metric in buckets of two hours. */
    Interval["TwoHours"] = "TWO_HOURS";
})(Interval || (exports.Interval = Interval = {}));
var InvalidActionReason;
(function (InvalidActionReason) {
    InvalidActionReason["NodeDoesNotExist"] = "NODE_DOES_NOT_EXIST";
    InvalidActionReason["RoleDoesNotExist"] = "ROLE_DOES_NOT_EXIST";
})(InvalidActionReason || (exports.InvalidActionReason = InvalidActionReason = {}));
var InvalidConditionReason;
(function (InvalidConditionReason) {
    InvalidConditionReason["InvalidValue"] = "INVALID_VALUE";
    InvalidConditionReason["ValueNotSpecified"] = "VALUE_NOT_SPECIFIED";
})(InvalidConditionReason || (exports.InvalidConditionReason = InvalidConditionReason = {}));
/** Invite status enum. */
var InviteStatus;
(function (InviteStatus) {
    /** The invite has been created, but has not been sent out yet. */
    InviteStatus["Created"] = "CREATED";
    /** The invite failed to send out. */
    InviteStatus["Failed"] = "FAILED";
    /** The person invited has finished registration and there is a user account created. */
    InviteStatus["Registered"] = "REGISTERED";
    /** The invite is in the process of being sent out. */
    InviteStatus["Sending"] = "SENDING";
    /** The invite has been sent successfully. */
    InviteStatus["Sent"] = "SENT";
})(InviteStatus || (exports.InviteStatus = InviteStatus = {}));
/** An enumeration that defines the invite type for the invites. */
var InviteType;
(function (InviteType) {
    /** Invite type is both external and internal. */
    InviteType["Both"] = "BOTH";
    /** Invite type is external. */
    InviteType["External"] = "EXTERNAL";
    /** Invite type is internal. */
    InviteType["Internal"] = "INTERNAL";
})(InviteType || (exports.InviteType = InviteType = {}));
/** An enumeration that defines the leaderboard time range. */
var LeaderboardTimeRange;
(function (LeaderboardTimeRange) {
    /** The time interval with no limit. */
    LeaderboardTimeRange["All"] = "ALL";
    /** The time interval of five years. */
    LeaderboardTimeRange["FiveYears"] = "FIVE_YEARS";
    /** The time interval of one day. */
    LeaderboardTimeRange["OneDay"] = "ONE_DAY";
    /** The time interval of one hour. */
    LeaderboardTimeRange["OneHour"] = "ONE_HOUR";
    /** The time interval of one minute. */
    LeaderboardTimeRange["OneMinute"] = "ONE_MINUTE";
    /** The time interval of one month. */
    LeaderboardTimeRange["OneMonth"] = "ONE_MONTH";
    /** The time interval of one week. */
    LeaderboardTimeRange["OneWeek"] = "ONE_WEEK";
    /** The time interval of one year. */
    LeaderboardTimeRange["OneYear"] = "ONE_YEAR";
    /** The time interval of six months. */
    LeaderboardTimeRange["SixMonths"] = "SIX_MONTHS";
    /** The time interval of three months. */
    LeaderboardTimeRange["ThreeMonths"] = "THREE_MONTHS";
})(LeaderboardTimeRange || (exports.LeaderboardTimeRange = LeaderboardTimeRange = {}));
/** Link Target Enum. */
var LinkTarget;
(function (LinkTarget) {
    LinkTarget["Blank"] = "BLANK";
    LinkTarget["Parent"] = "PARENT";
    LinkTarget["Self"] = "SELF";
    LinkTarget["Top"] = "TOP";
})(LinkTarget || (exports.LinkTarget = LinkTarget = {}));
/** Link type enum. */
var LinkType;
(function (LinkType) {
    LinkType["External"] = "EXTERNAL";
    LinkType["Internal"] = "INTERNAL";
})(LinkType || (exports.LinkType = LinkType = {}));
/** Enumerates the types of long form fields. */
var LongCustomFormFieldType;
(function (LongCustomFormFieldType) {
    /** AN input field. */
    LongCustomFormFieldType["Input"] = "INPUT";
    /** A range field. */
    LongCustomFormFieldType["Range"] = "RANGE";
})(LongCustomFormFieldType || (exports.LongCustomFormFieldType = LongCustomFormFieldType = {}));
/** An enumeration that defines the different template types. */
var MailTemplateField;
(function (MailTemplateField) {
    /** The template HTML field. */
    MailTemplateField["Html"] = "HTML";
    /** The template subject field. */
    MailTemplateField["Subject"] = "SUBJECT";
    /** The template text field. */
    MailTemplateField["Text"] = "TEXT";
})(MailTemplateField || (exports.MailTemplateField = MailTemplateField = {}));
/** An enumeration that defines the different mail templates available in the Community. */
var MailTemplateName;
(function (MailTemplateName) {
    MailTemplateName["AcceptAsSolutionReminder"] = "ACCEPT_AS_SOLUTION_REMINDER";
    MailTemplateName["AnswerAcceptedAsSolution"] = "ANSWER_ACCEPTED_AS_SOLUTION";
    MailTemplateName["AwardUserBadge"] = "AWARD_USER_BADGE";
    MailTemplateName["ContentMentions"] = "CONTENT_MENTIONS";
    MailTemplateName["CoAuthorNotification"] = "CO_AUTHOR_NOTIFICATION";
    MailTemplateName["CwaNotification"] = "CWA_NOTIFICATION";
    MailTemplateName["DigestNotification"] = "DIGEST_NOTIFICATION";
    MailTemplateName["EmailChangeConfirm"] = "EMAIL_CHANGE_CONFIRM";
    MailTemplateName["EmailVerifyConfirm"] = "EMAIL_VERIFY_CONFIRM";
    MailTemplateName["ForgotPassword"] = "FORGOT_PASSWORD";
    MailTemplateName["ImmediateGeneral"] = "IMMEDIATE_GENERAL";
    MailTemplateName["InvitedUserRegistration"] = "INVITED_USER_REGISTRATION";
    MailTemplateName["Likes"] = "LIKES";
    MailTemplateName["MembershipInviteRequest"] = "MEMBERSHIP_INVITE_REQUEST";
    MailTemplateName["MembershipUserRequest"] = "MEMBERSHIP_USER_REQUEST";
    MailTemplateName["Mentions"] = "MENTIONS";
    MailTemplateName["MessageDeletionNotification"] = "MESSAGE_DELETION_NOTIFICATION";
    MailTemplateName["MessagePostConfirm"] = "MESSAGE_POST_CONFIRM";
    MailTemplateName["ModeratorNotification"] = "MODERATOR_NOTIFICATION";
    MailTemplateName["OccasionInvite"] = "OCCASION_INVITE";
    MailTemplateName["OccasionReminder"] = "OCCASION_REMINDER";
    MailTemplateName["PmNotification"] = "PM_NOTIFICATION";
    MailTemplateName["RegistrationConfirm"] = "REGISTRATION_CONFIRM";
    MailTemplateName["SalesforceIntegrationNotification"] = "SALESFORCE_INTEGRATION_NOTIFICATION";
    MailTemplateName["SolutionToQuestion"] = "SOLUTION_TO_QUESTION";
    MailTemplateName["UserRankChange"] = "USER_RANK_CHANGE";
})(MailTemplateName || (exports.MailTemplateName = MailTemplateName = {}));
var ManualSortOrderType;
(function (ManualSortOrderType) {
    /** Sort articles based on likes. */
    ManualSortOrderType["Likes"] = "LIKES";
    /** Sort articles based on creation time. */
    ManualSortOrderType["Publishtime"] = "PUBLISHTIME";
    /** Sort articles based on reverse creation time. */
    ManualSortOrderType["Reversepublishtime"] = "REVERSEPUBLISHTIME";
})(ManualSortOrderType || (exports.ManualSortOrderType = ManualSortOrderType = {}));
/** An enumeration representing media type. */
var MediaType;
(function (MediaType) {
    MediaType["Attachments"] = "ATTACHMENTS";
    MediaType["Images"] = "IMAGES";
    MediaType["Videos"] = "VIDEOS";
})(MediaType || (exports.MediaType = MediaType = {}));
/** Member registration status enum. */
var MemberRegistrationStatus;
(function (MemberRegistrationStatus) {
    MemberRegistrationStatus["FullyRegistered"] = "FULLY_REGISTERED";
    MemberRegistrationStatus["PartiallyRegistered"] = "PARTIALLY_REGISTERED";
})(MemberRegistrationStatus || (exports.MemberRegistrationStatus = MemberRegistrationStatus = {}));
/** Defines enum for all applicable sort metrics for memberReport. */
var MemberReportSortMetric;
(function (MemberReportSortMetric) {
    /** Number of the blog comments published. */
    MemberReportSortMetric["BlogCommentsPublished"] = "BLOG_COMMENTS_PUBLISHED";
    /** Number of the blog articles published. */
    MemberReportSortMetric["BlogPostsPublished"] = "BLOG_POSTS_PUBLISHED";
    /** Number of the forum topics. */
    MemberReportSortMetric["ForumDiscussionsPublished"] = "FORUM_DISCUSSIONS_PUBLISHED";
    /** Number of the forum replies published. */
    MemberReportSortMetric["ForumRepliesPublished"] = "FORUM_REPLIES_PUBLISHED";
    /** Number of Idea Submitted */
    MemberReportSortMetric["IdeasSubmitted"] = "IDEAS_SUBMITTED";
    /** Number of Idea Votes given */
    MemberReportSortMetric["IdeaVotes"] = "IDEA_VOTES";
    /** Number of Idea Votes received */
    MemberReportSortMetric["IdeaVotesReceived"] = "IDEA_VOTES_RECEIVED";
    /** Likes given. */
    MemberReportSortMetric["KudosGiven"] = "KUDOS_GIVEN";
    /** Likes received. */
    MemberReportSortMetric["KudosReceived"] = "KUDOS_RECEIVED";
    /** Number of subscriptions made on nodes. */
    MemberReportSortMetric["NodeSubscriptions"] = "NODE_SUBSCRIPTIONS";
    /** Number of occasion created. */
    MemberReportSortMetric["OccasionsCreated"] = "OCCASIONS_CREATED";
    /** Attendance of the occasion */
    MemberReportSortMetric["OccasionAttendance"] = "OCCASION_ATTENDANCE";
    /** Number of Occasion Attending RSVPs */
    MemberReportSortMetric["OccasionRsvpAttending"] = "OCCASION_RSVP_ATTENDING";
    /** Number of Occasion Interested RSVPs */
    MemberReportSortMetric["OccasionRsvpInterested"] = "OCCASION_RSVP_INTERESTED";
    /**
     * A page view is counted each time a browser requests a page, regardless of the device type or whether the page is
     * cached. Page views approximates user behavior and therefore excludes non-human requests (Web crawlers,
     * robots, RSS feeds, REST API calls, ActiveCast calls, and LevelUp requests).
     */
    MemberReportSortMetric["PageViews"] = "PAGE_VIEWS";
    /** Number of subscriptions made on posts. */
    MemberReportSortMetric["PostSubscriptions"] = "POST_SUBSCRIPTIONS";
    /** Number of replies accepted as solution to the parent topic by the user. */
    MemberReportSortMetric["SolutionsAccepted"] = "SOLUTIONS_ACCEPTED";
    /** Number of user's replies accepted as solution to the parent topic by others. */
    MemberReportSortMetric["SolutionsAuthored"] = "SOLUTIONS_AUTHORED";
    /** Number of replies viewed as solution to the parent topic. */
    MemberReportSortMetric["SolutionsViews"] = "SOLUTIONS_VIEWS";
    /** Number of the KB articles posted. */
    MemberReportSortMetric["TkbArticlesPublished"] = "TKB_ARTICLES_PUBLISHED";
    /** Number of the comments published. */
    MemberReportSortMetric["TkbCommentsPublished"] = "TKB_COMMENTS_PUBLISHED";
    /** A visit is one or more page views over time by a uniquely identified client (visitor). */
    MemberReportSortMetric["Visits"] = "VISITS";
})(MemberReportSortMetric || (exports.MemberReportSortMetric = MemberReportSortMetric = {}));
/** An enumeration that defines what membership type a given membership node uses. */
var MembershipType;
(function (MembershipType) {
    /** Membership is closed. */
    MembershipType["Closed"] = "CLOSED";
    /** Membership is closed and the node is hidden to non-members. */
    MembershipType["ClosedHidden"] = "CLOSED_HIDDEN";
    /** Membership is open. */
    MembershipType["Open"] = "OPEN";
})(MembershipType || (exports.MembershipType = MembershipType = {}));
/** Configuration types required for different metrics. */
var MetricConfigName;
(function (MetricConfigName) {
    /** Cost of each customer support contact. */
    MetricConfigName["CostPerContact"] = "COST_PER_CONTACT";
    /** Threshold for number of search impressions for keywords in search. */
    MetricConfigName["SearchHotKeywordsThreshold"] = "SEARCH_HOT_KEYWORDS_THRESHOLD";
    /** List of roles which are assigned to internal staff of the community. */
    MetricConfigName["StaffRoles"] = "STAFF_ROLES";
    /** Page view threshold for a topic without solution to be considered as a trending topic. */
    MetricConfigName["TopicsNeededSolutionThreshold"] = "TOPICS_NEEDED_SOLUTION_THRESHOLD";
    /** Time to first reply threshold for a topic. */
    MetricConfigName["TopicsTfrExceededThreshold"] = "TOPICS_TFR_EXCEEDED_THRESHOLD";
    /** Page view threshold for a topic to be considered a trending topic. */
    MetricConfigName["TopicsTrendingThreshold"] = "TOPICS_TRENDING_THRESHOLD";
})(MetricConfigName || (exports.MetricConfigName = MetricConfigName = {}));
var MetricContentScope;
(function (MetricContentScope) {
    MetricContentScope["CategoryConversationLevel"] = "CATEGORY_CONVERSATION_LEVEL";
    MetricContentScope["CommunityBoardConversationLevel"] = "COMMUNITY_BOARD_CONVERSATION_LEVEL";
    MetricContentScope["ConversationLevel"] = "CONVERSATION_LEVEL";
    MetricContentScope["GrouphubConversationLevel"] = "GROUPHUB_CONVERSATION_LEVEL";
})(MetricContentScope || (exports.MetricContentScope = MetricContentScope = {}));
/** Dimensions types available in the API to segregate the result on. */
var MetricDimension;
(function (MetricDimension) {
    /** Bucketize the metric in buckets individual conversation IDs. */
    MetricDimension["ConversationUid"] = "CONVERSATION_UID";
    /** Bucketize the metric in buckets individual target user IDs. */
    MetricDimension["TargetUserUid"] = "TARGET_USER_UID";
    /** Bucketize the metric in buckets individual user IDs. */
    MetricDimension["UserUid"] = "USER_UID";
})(MetricDimension || (exports.MetricDimension = MetricDimension = {}));
/** Filter types available to apply on the metric data. */
var MetricFilterName;
(function (MetricFilterName) {
    /** Scopes the results to given board IDs. */
    MetricFilterName["BoardId"] = "BOARD_ID";
    /** Scopes the results to given category IDs. */
    MetricFilterName["CategoryId"] = "CATEGORY_ID";
    /** Scopes the results to given community application, AKA conversation_style. */
    MetricFilterName["CommunityApp"] = "COMMUNITY_APP";
    /** Scopes the results to given conversation or thread IDs. */
    MetricFilterName["ConversationUid"] = "CONVERSATION_UID";
    /** Scopes the results to exclude staffs. */
    MetricFilterName["ExcludeStaff"] = "EXCLUDE_STAFF";
    /** Scopes the results to given survey response question ID. */
    MetricFilterName["SurveyResponseQuestionId"] = "SURVEY_RESPONSE_QUESTION_ID";
    /** Scopes the results to given target user IDs. */
    MetricFilterName["TargetUserUid"] = "TARGET_USER_UID";
    /** Scopes the results to given community user ranks. */
    MetricFilterName["UserCommunityRankName"] = "USER_COMMUNITY_RANK_NAME";
    /** Scopes the results to given community user roles. */
    MetricFilterName["UserCommunityRoleName"] = "USER_COMMUNITY_ROLE_NAME";
    /** Scopes the results to given user IDs. */
    MetricFilterName["UserUid"] = "USER_UID";
    /** Scopes the results to given user types of user analytics */
    MetricFilterName["ValueAnalyticsUserType"] = "VALUE_ANALYTICS_USER_TYPE";
})(MetricFilterName || (exports.MetricFilterName = MetricFilterName = {}));
/** Metrics types available in the API. */
var MetricName;
(function (MetricName) {
    /** Number of registered members of community with having at least one page view in the date range selected. */
    MetricName["ActiveMembers"] = "ACTIVE_MEMBERS";
    /** Page views from the unregistered users of the community. */
    MetricName["AnonymousTraffic"] = "ANONYMOUS_TRAFFIC";
    /** Average number of minutes each visitor spends on the community. */
    MetricName["AvgSessionDuration"] = "AVG_SESSION_DURATION";
    /** Number of the blog articles published. */
    MetricName["BlogArticlesPublished"] = "BLOG_ARTICLES_PUBLISHED";
    /** Business value metric. */
    MetricName["BusinessValue"] = "BUSINESS_VALUE";
    /** Members who have made at least one post. */
    MetricName["ContributingMembers"] = "CONTRIBUTING_MEMBERS";
    /** Ratio of contributing members over all active members in community. */
    MetricName["ContributionRatio"] = "CONTRIBUTION_RATIO";
    /** Members who have made at least one post. */
    MetricName["Contributors"] = "CONTRIBUTORS";
    /** Number of conversations member have participated in. */
    MetricName["ConversationsParticipated"] = "CONVERSATIONS_PARTICIPATED";
    /** Customer satisfaction metric. */
    MetricName["CSat"] = "C_SAT";
    /** Daily active users (having at least one page view). */
    MetricName["Dau"] = "DAU";
    /** Ratio of daily active users over monthly active users. */
    MetricName["DauMau"] = "DAU_MAU";
    /** Engagement trend. */
    MetricName["EngagementTrend"] = "ENGAGEMENT_TREND";
    /** Number of users who are the first time making a post in the community. */
    MetricName["FirstTimeContributors"] = "FIRST_TIME_CONTRIBUTORS";
    /** The total number of replies made on forum and q&a posts. */
    MetricName["ForumAndQnaReplies"] = "FORUM_AND_QNA_REPLIES";
    /** The total number of posts created on forum and q&a. */
    MetricName["ForumAndQnaTopics"] = "FORUM_AND_QNA_TOPICS";
    /** Number of forum replies */
    MetricName["ForumRepliesPublished"] = "FORUM_REPLIES_PUBLISHED";
    /** Number of forum topics. */
    MetricName["ForumTopicsPublished"] = "FORUM_TOPICS_PUBLISHED";
    /** Number of all first replies to forum topics. */
    MetricName["ForumTopicFirstReply"] = "FORUM_TOPIC_FIRST_REPLY";
    /** Average time to first reply for forums. */
    MetricName["ForumTopicFirstReplyAvgTime"] = "FORUM_TOPIC_FIRST_REPLY_AVG_TIME";
    /** Average time to the first solution for forums. */
    MetricName["ForumTopicFirstSolutionAvgTime"] = "FORUM_TOPIC_FIRST_SOLUTION_AVG_TIME";
    /** Number of ideas marked as executed. */
    MetricName["IdeasExecuted"] = "IDEAS_EXECUTED";
    /** Number of ideas submitted. */
    MetricName["IdeasSubmitted"] = "IDEAS_SUBMITTED";
    /** Likes given. */
    MetricName["KudosGiven"] = "KUDOS_GIVEN";
    /** Number of likes received by member. */
    MetricName["KudosReceived"] = "KUDOS_RECEIVED";
    /** Monthly active users (having at least one page view). */
    MetricName["Mau"] = "MAU";
    /** Median of the number of private messages. */
    MetricName["MedianPrivateMessages"] = "MEDIAN_PRIVATE_MESSAGES";
    /** Page views from the registered members of the community. */
    MetricName["MembersTraffic"] = "MEMBERS_TRAFFIC";
    /** The number of the user registrations completed during the selected time period (excludes abandoned registrations). */
    MetricName["MemberRegistrations"] = "MEMBER_REGISTRATIONS";
    /** Topics by replies metric for the new topics created. */
    MetricName["NewTopicsByReplies"] = "NEW_TOPICS_BY_REPLIES";
    /** New users visiting the community. */
    MetricName["NewUsers"] = "NEW_USERS";
    /** Number of subscriptions made on nodes. */
    MetricName["NodeSubscriptions"] = "NODE_SUBSCRIPTIONS";
    /** Number of un-subscriptions made on nodes. */
    MetricName["NodeUnsubscriptions"] = "NODE_UNSUBSCRIPTIONS";
    /** Net Promoter Score metric. */
    MetricName["Nps"] = "NPS";
    /**
     * A page view is counted each time a browser requests a page, regardless of the device type or whether the page is
     * cached. Page views approximates user behavior and therefore excludes non-human requests (Web crawlers,
     * robots, RSS feeds, REST API calls, ActiveCast calls, and LevelUp requests).
     */
    MetricName["PageViews"] = "PAGE_VIEWS";
    /** The number of the user registrations (partial) during the selected time period (excludes completed registrations). */
    MetricName["PartialRegistrations"] = "PARTIAL_REGISTRATIONS";
    /** Members who have participated, i.e. solution accept, kudo etc. */
    MetricName["ParticipatingMembers"] = "PARTICIPATING_MEMBERS";
    /** Ratio of participating members over all active members in community. */
    MetricName["ParticipationRatio"] = "PARTICIPATION_RATIO";
    /** Number of subscriptions made on posts. */
    MetricName["PostSubscriptions"] = "POST_SUBSCRIPTIONS";
    /** Number of un-subscriptions made on posts. */
    MetricName["PostUnsubscriptions"] = "POST_UNSUBSCRIPTIONS";
    /** Number of private message conversations. */
    MetricName["PrivateConversations"] = "PRIVATE_CONVERSATIONS";
    /** The total number of replies given on posts. */
    MetricName["Replies"] = "REPLIES";
    /** Users visiting the community, who have visited the community in past. */
    MetricName["ReturningUsers"] = "RETURNING_USERS";
    /** Number of searches performed in the community. */
    MetricName["Searches"] = "SEARCHES";
    /** Search hot keywords. */
    MetricName["SearchHotKeywords"] = "SEARCH_HOT_KEYWORDS";
    /** Number of replies accepted as solution to the parent topic. */
    MetricName["SolutionsAccepted"] = "SOLUTIONS_ACCEPTED";
    /** Page views on topic with the accepted solutions. */
    MetricName["SolutionsViews"] = "SOLUTIONS_VIEWS";
    /** Survey question helpful. */
    MetricName["SurveyQuestionHelpful"] = "SURVEY_QUESTION_HELPFUL";
    /** Survey question helpful 'yes' then. */
    MetricName["SurveyQuestionHelpfulYesThen"] = "SURVEY_QUESTION_HELPFUL_YES_THEN";
    /** Survey question purpose. */
    MetricName["SurveyQuestionPurpose"] = "SURVEY_QUESTION_PURPOSE";
    /** Surveys submitted. */
    MetricName["SurveySubmit"] = "SURVEY_SUBMIT";
    /** Number of KB articles posted. */
    MetricName["TkbArticlesPublished"] = "TKB_ARTICLES_PUBLISHED";
    /** The total number of posts created. */
    MetricName["Topics"] = "TOPICS";
    /** Topic contributors. */
    MetricName["TopicsContributors"] = "TOPICS_CONTRIBUTORS";
    /** Topics trending in the community which do not have any reply accepted as its solution. */
    MetricName["TopicsNeededSolution"] = "TOPICS_NEEDED_SOLUTION";
    /** Topics which do not have any replies, even after 't' minutes have passed from the creation time of the topic. */
    MetricName["TopicsTfrExceeded"] = "TOPICS_TFR_EXCEEDED";
    /** Topics trending in the community i.e. having at least 'n' page views. */
    MetricName["TopicsTrending"] = "TOPICS_TRENDING";
    /** Topic by replies metric for trending topics. */
    MetricName["TrendingTopicsByReplies"] = "TRENDING_TOPICS_BY_REPLIES";
    /** Unique number of visitors. */
    MetricName["UniqueVisitors"] = "UNIQUE_VISITORS";
    /** User activity metrics. */
    MetricName["UserActivity"] = "USER_ACTIVITY";
    /** A visit is one or more page views over time by a uniquely identified client (visitor). */
    MetricName["Visits"] = "VISITS";
})(MetricName || (exports.MetricName = MetricName = {}));
var MetricNodeScope;
(function (MetricNodeScope) {
    MetricNodeScope["BoardLevel"] = "BOARD_LEVEL";
    MetricNodeScope["CategoryBoardLevel"] = "CATEGORY_BOARD_LEVEL";
    MetricNodeScope["CategoryGrouphubLevel"] = "CATEGORY_GROUPHUB_LEVEL";
    MetricNodeScope["CategoryLevel"] = "CATEGORY_LEVEL";
    MetricNodeScope["CommunityBoardLevel"] = "COMMUNITY_BOARD_LEVEL";
    MetricNodeScope["CommunityGrouphubLevel"] = "COMMUNITY_GROUPHUB_LEVEL";
    MetricNodeScope["CommunityLevel"] = "COMMUNITY_LEVEL";
    MetricNodeScope["GrouphubBoardLevel"] = "GROUPHUB_BOARD_LEVEL";
    MetricNodeScope["GrouphubLevel"] = "GROUPHUB_LEVEL";
})(MetricNodeScope || (exports.MetricNodeScope = MetricNodeScope = {}));
/** Metric response message code types. */
var MetricResponseMessageCode;
(function (MetricResponseMessageCode) {
    /** Error response, with error message in MetricResponseMessage. */
    MetricResponseMessageCode["Error"] = "ERROR";
    /** OK response, may accompany informative messages in MetricResponseMessage. */
    MetricResponseMessageCode["Ok"] = "OK";
})(MetricResponseMessageCode || (exports.MetricResponseMessageCode = MetricResponseMessageCode = {}));
/** An enum representing the actor type who has moderated the particular message as spam. */
var ModeratingActorType;
(function (ModeratingActorType) {
    /** All actor types. */
    ModeratingActorType["All"] = "ALL";
    /** Community member user actor type. */
    ModeratingActorType["Member"] = "MEMBER";
    /** System(Automated Spam filter) actor type. */
    ModeratingActorType["System"] = "SYSTEM";
})(ModeratingActorType || (exports.ModeratingActorType = ModeratingActorType = {}));
var ModerationAction;
(function (ModerationAction) {
    /** Approve itam via moderation. */
    ModerationAction["Approve"] = "APPROVE";
    /** Mark as not spam. */
    ModerationAction["NotSpam"] = "NOT_SPAM";
    /** Recall moderation and make unmoderated. */
    ModerationAction["Recall"] = "RECALL";
    /** Reject item via Moderation. */
    ModerationAction["Reject"] = "REJECT";
    /** Mark as spam. */
    ModerationAction["Spam"] = "SPAM";
})(ModerationAction || (exports.ModerationAction = ModerationAction = {}));
/** enum for moderation permission. */
var ModerationPermissions;
(function (ModerationPermissions) {
    /** Bypass content filter permission. */
    ModerationPermissions["AllowBypassFilters"] = "ALLOW_BYPASS_FILTERS";
    /** Blog bypass moderation permission. */
    ModerationPermissions["BlogBypassModeration"] = "BLOG_BYPASS_MODERATION";
    /** Bypass spam rejection permission. */
    ModerationPermissions["BypassAutomaticEvaluation"] = "BYPASS_AUTOMATIC_EVALUATION";
    /** Bypass flood control permission. */
    ModerationPermissions["BypassFloodControl"] = "BYPASS_FLOOD_CONTROL";
    /** Forum bypass moderation permission. */
    ModerationPermissions["ForumBypassModeration"] = "FORUM_BYPASS_MODERATION";
    /** Idea bypass moderation permission. */
    ModerationPermissions["IdeaBypassModeration"] = "IDEA_BYPASS_MODERATION";
    /** Media bypass moderation permission. */
    ModerationPermissions["MediaBypassModeration"] = "MEDIA_BYPASS_MODERATION";
    /** Occasion bypass moderation permission. */
    ModerationPermissions["OccasionBypassModeration"] = "OCCASION_BYPASS_MODERATION";
    /** Tkb bypass moderation permission. */
    ModerationPermissions["TkbBypassModeration"] = "TKB_BYPASS_MODERATION";
})(ModerationPermissions || (exports.ModerationPermissions = ModerationPermissions = {}));
/** Defines an enumeration for moderation statuses. */
var ModerationStatus;
(function (ModerationStatus) {
    ModerationStatus["Approved"] = "APPROVED";
    ModerationStatus["MarkedApproved"] = "MARKED_APPROVED";
    ModerationStatus["MarkedRejected"] = "MARKED_REJECTED";
    ModerationStatus["MarkedUndecided"] = "MARKED_UNDECIDED";
    ModerationStatus["Rejected"] = "REJECTED";
    ModerationStatus["Unmoderated"] = "UNMODERATED";
})(ModerationStatus || (exports.ModerationStatus = ModerationStatus = {}));
/** Enum that specifies all the allowed moderation styles. */
var ModerationStyle;
(function (ModerationStyle) {
    /** No-mod. */
    ModerationStyle["Off"] = "OFF";
    /** Post-mod. */
    ModerationStyle["Post"] = "POST";
    /** Pre-mod. */
    ModerationStyle["Pre"] = "PRE";
})(ModerationStyle || (exports.ModerationStyle = ModerationStyle = {}));
/** Defines an enum for the navbar position. */
var NavbarPosition;
(function (NavbarPosition) {
    /** Fixed style navbar that scrolls with the page. */
    NavbarPosition["Fixed"] = "FIXED";
    /** Normal style navbar that is static on the page. */
    NavbarPosition["Normal"] = "NORMAL";
})(NavbarPosition || (exports.NavbarPosition = NavbarPosition = {}));
/** Defines enum for all applicable sort metrics for newTopicByRepliesReport. */
var NewTopicsByRepliesReportSortMetric;
(function (NewTopicsByRepliesReportSortMetric) {
    /** Likes given. */
    NewTopicsByRepliesReportSortMetric["KudosGiven"] = "KUDOS_GIVEN";
    /**
     * A page view is counted each time a browser requests a page, regardless of the device type or whether the page is
     * cached. Page Views approximates user behavior and therefore excludes non-human requests (Web crawlers,
     * robots, RSS feeds, REST API calls, ActiveCast calls, and LevelUp requests).
     */
    NewTopicsByRepliesReportSortMetric["PageViews"] = "PAGE_VIEWS";
    /** Replies published. */
    NewTopicsByRepliesReportSortMetric["RepliesPublished"] = "REPLIES_PUBLISHED";
})(NewTopicsByRepliesReportSortMetric || (exports.NewTopicsByRepliesReportSortMetric = NewTopicsByRepliesReportSortMetric = {}));
/** Enum that defines all access level for a permission at a category, grouphub, and board level */
var NodeAccess;
(function (NodeAccess) {
    NodeAccess["Denied"] = "DENIED";
    NodeAccess["Granted"] = "GRANTED";
    NodeAccess["Inherited"] = "INHERITED";
})(NodeAccess || (exports.NodeAccess = NodeAccess = {}));
var NodeType;
(function (NodeType) {
    NodeType["Category"] = "CATEGORY";
    NodeType["Grouphub"] = "GROUPHUB";
})(NodeType || (exports.NodeType = NodeType = {}));
/** Enumerates the possible Query Operators for number-based values. */
var NumberQueryOperator;
(function (NumberQueryOperator) {
    /** Equals (=) */
    NumberQueryOperator["Eq"] = "EQ";
    /** Greater Than (>) */
    NumberQueryOperator["Gt"] = "GT";
    /** Greater Than or Equal to (>=) */
    NumberQueryOperator["Gte"] = "GTE";
    /** In (in) */
    NumberQueryOperator["In"] = "IN";
    /** Less Than (<) */
    NumberQueryOperator["Lt"] = "LT";
    /** Less Than or Equal To (<=) */
    NumberQueryOperator["Lte"] = "LTE";
    /** Not Equals (!=) */
    NumberQueryOperator["Neq"] = "NEQ";
    /** Not In (nin) */
    NumberQueryOperator["Nin"] = "NIN";
})(NumberQueryOperator || (exports.NumberQueryOperator = NumberQueryOperator = {}));
var OEmbedType;
(function (OEmbedType) {
    OEmbedType["Error"] = "ERROR";
    OEmbedType["Link"] = "LINK";
    OEmbedType["Rich"] = "RICH";
    OEmbedType["Video"] = "VIDEO";
})(OEmbedType || (exports.OEmbedType = OEmbedType = {}));
var OccasionBoardReportSortMetric;
(function (OccasionBoardReportSortMetric) {
    /** Kudos on event. */
    OccasionBoardReportSortMetric["KudosGiven"] = "KUDOS_GIVEN";
    /** Number of subscriptions made on nodes. */
    OccasionBoardReportSortMetric["NodeSubscriptions"] = "NODE_SUBSCRIPTIONS";
    /** Number of occasion created. */
    OccasionBoardReportSortMetric["OccasionsCreated"] = "OCCASIONS_CREATED";
    /** Attendance of the occasion */
    OccasionBoardReportSortMetric["OccasionAttendance"] = "OCCASION_ATTENDANCE";
    /** Number of comments on occasion */
    OccasionBoardReportSortMetric["OccasionComments"] = "OCCASION_COMMENTS";
    /** Number of Occasion Attending RSVPs */
    OccasionBoardReportSortMetric["OccasionRsvpAttending"] = "OCCASION_RSVP_ATTENDING";
    /** Number of Occasion Interested RSVPs */
    OccasionBoardReportSortMetric["OccasionRsvpInterested"] = "OCCASION_RSVP_INTERESTED";
    /**
     * A page view is counted each time a browser requests a page, regardless of the device type or whether the page is
     * cached. Page Views approximates user behavior and therefore excludes non-human requests (Web crawlers,
     * robots, RSS feeds, REST API calls, ActiveCast calls, and LevelUp requests).
     */
    OccasionBoardReportSortMetric["PageViews"] = "PAGE_VIEWS";
    /** Unique number of visitors. */
    OccasionBoardReportSortMetric["UniqueVisitors"] = "UNIQUE_VISITORS";
    /** A visit is one or more page views over time by a uniquely identified client (visitor). */
    OccasionBoardReportSortMetric["Visits"] = "VISITS";
})(OccasionBoardReportSortMetric || (exports.OccasionBoardReportSortMetric = OccasionBoardReportSortMetric = {}));
/** Enum containing the allowed values for occasion status filter type. */
var OccasionStatusFilterType;
(function (OccasionStatusFilterType) {
    /** The occasions which are taking place at present. */
    OccasionStatusFilterType["Ongoing"] = "ONGOING";
    /** The occasions which have already ended. */
    OccasionStatusFilterType["Past"] = "PAST";
    /** The occasions which are scheduled for a future time. */
    OccasionStatusFilterType["Upcoming"] = "UPCOMING";
})(OccasionStatusFilterType || (exports.OccasionStatusFilterType = OccasionStatusFilterType = {}));
/** Enum containing the allowed values for occasion status filter type. */
var OccasionType;
(function (OccasionType) {
    /** The occasions which have both live stream url and physical location. */
    OccasionType["Hybrid"] = "HYBRID";
    /** The occasions which have a physical location */
    OccasionType["InPerson"] = "IN_PERSON";
    /** The occasions which have a live stream url. */
    OccasionType["Live"] = "LIVE";
})(OccasionType || (exports.OccasionType = OccasionType = {}));
var OccasionsReportSortMetric;
(function (OccasionsReportSortMetric) {
    /** Likes given. */
    OccasionsReportSortMetric["KudosGiven"] = "KUDOS_GIVEN";
    /** Attendance of the occasion */
    OccasionsReportSortMetric["OccasionAttendance"] = "OCCASION_ATTENDANCE";
    /** Number of occasions comments published */
    OccasionsReportSortMetric["OccasionComments"] = "OCCASION_COMMENTS";
    /** Number of Occasion Attending RSVPs */
    OccasionsReportSortMetric["OccasionRsvpAttending"] = "OCCASION_RSVP_ATTENDING";
    /** Number of Occasion Interested RSVPs */
    OccasionsReportSortMetric["OccasionRsvpInterested"] = "OCCASION_RSVP_INTERESTED";
    /**
     * A page view is counted each time a browser requests a page, regardless of the device type or whether the page is
     * cached. Page Views approximates user behavior and therefore excludes non-human requests (Web crawlers,
     * robots, RSS feeds, REST API calls, ActiveCast calls, and LevelUp requests).
     */
    OccasionsReportSortMetric["PageViews"] = "PAGE_VIEWS";
    /** Number of subscriptions made on articles. */
    OccasionsReportSortMetric["PostSubscriptions"] = "POST_SUBSCRIPTIONS";
    /** Unique number of visitors. */
    OccasionsReportSortMetric["UniqueVisitors"] = "UNIQUE_VISITORS";
    /** A visit is one or more page views over time by a uniquely identified client (visitor). */
    OccasionsReportSortMetric["Visits"] = "VISITS";
})(OccasionsReportSortMetric || (exports.OccasionsReportSortMetric = OccasionsReportSortMetric = {}));
var Operator;
(function (Operator) {
    Operator["EqualTo"] = "EQUAL_TO";
    Operator["GreaterThan"] = "GREATER_THAN";
    Operator["GreaterThanOrEquals"] = "GREATER_THAN_OR_EQUALS";
    Operator["LessThan"] = "LESS_THAN";
    Operator["LessThanOrEquals"] = "LESS_THAN_OR_EQUALS";
    Operator["NotEqualTo"] = "NOT_EQUAL_TO";
})(Operator || (exports.Operator = Operator = {}));
/** Enumerates the possible Page Script Groups. */
var PageScriptGroup;
(function (PageScriptGroup) {
    /** The afterInteractive group. */
    PageScriptGroup["AfterInteractive"] = "AFTER_INTERACTIVE";
    /** The beforeInteractiveFirst group. */
    PageScriptGroup["BeforeInteractiveFirst"] = "BEFORE_INTERACTIVE_FIRST";
    /** The beforeInteractiveLast group. */
    PageScriptGroup["BeforeInteractiveLast"] = "BEFORE_INTERACTIVE_LAST";
    /** The lazyOnLoad group. */
    PageScriptGroup["LazyOnLoad"] = "LAZY_ON_LOAD";
})(PageScriptGroup || (exports.PageScriptGroup = PageScriptGroup = {}));
/** Enumerates the possible Page Script Provider. */
var PageScriptProvider;
(function (PageScriptProvider) {
    /** Adobe analytics. */
    PageScriptProvider["AdobeAnalytics"] = "ADOBE_ANALYTICS";
    /** Google analytics. */
    PageScriptProvider["GoogleAnalytics"] = "GOOGLE_ANALYTICS";
    /** Google tag manager. */
    PageScriptProvider["GoogleTagManager"] = "GOOGLE_TAG_MANAGER";
    /** Meta pixel. */
    PageScriptProvider["MetaPixel"] = "META_PIXEL";
})(PageScriptProvider || (exports.PageScriptProvider = PageScriptProvider = {}));
var PageViewsByType;
(function (PageViewsByType) {
    /** Page views drill down by board */
    PageViewsByType["Board"] = "BOARD";
    /** Page views drill down by topic */
    PageViewsByType["Topic"] = "TOPIC";
})(PageViewsByType || (exports.PageViewsByType = PageViewsByType = {}));
/** An enumeration that defines what PlaceTypeEnum a given node contains. */
var PlaceTypeEnum;
(function (PlaceTypeEnum) {
    PlaceTypeEnum["Board"] = "BOARD";
    PlaceTypeEnum["Category"] = "CATEGORY";
    PlaceTypeEnum["Grouphub"] = "GROUPHUB";
})(PlaceTypeEnum || (exports.PlaceTypeEnum = PlaceTypeEnum = {}));
/** An enumeration that defines the host location. */
var PolicyHostLocation;
(function (PolicyHostLocation) {
    /** Defines it is hosted externally via customers */
    PolicyHostLocation["External"] = "EXTERNAL";
    /** Defines it is hosted internally(Community default) */
    PolicyHostLocation["Internal"] = "INTERNAL";
})(PolicyHostLocation || (exports.PolicyHostLocation = PolicyHostLocation = {}));
/** An enumeration representing the type of autosave. */
var PostMessageType;
(function (PostMessageType) {
    /** This autosave is for an edit of an existing message. */
    PostMessageType["Edit"] = "EDIT";
    /** This autosave is for a new post. */
    PostMessageType["Post"] = "POST";
    /** This autosave is for a reply to another message. */
    PostMessageType["Reply"] = "REPLY";
})(PostMessageType || (exports.PostMessageType = PostMessageType = {}));
/** An enumeration that defines the moderation action on a private note or conversation. */
var PrivateNoteModerationAction;
(function (PrivateNoteModerationAction) {
    PrivateNoteModerationAction["Approve"] = "APPROVE";
    PrivateNoteModerationAction["Ignore"] = "IGNORE";
    PrivateNoteModerationAction["RejectAsAbuse"] = "REJECT_AS_ABUSE";
})(PrivateNoteModerationAction || (exports.PrivateNoteModerationAction = PrivateNoteModerationAction = {}));
/** An enum representing the status of a product category. */
var ProductCategoryStatus;
(function (ProductCategoryStatus) {
    /** The product categry is active. */
    ProductCategoryStatus["Active"] = "ACTIVE";
    /** The product category is inactive (has been logically deleted). */
    ProductCategoryStatus["Inactive"] = "INACTIVE";
})(ProductCategoryStatus || (exports.ProductCategoryStatus = ProductCategoryStatus = {}));
/** An enum representing the status of a product. */
var ProductStatus;
(function (ProductStatus) {
    /** The product is active. */
    ProductStatus["Active"] = "ACTIVE";
    /** The product is inactive (has been logically deleted). */
    ProductStatus["Inactive"] = "INACTIVE";
})(ProductStatus || (exports.ProductStatus = ProductStatus = {}));
/**
 * Enumerates the choices for analyzing a field when indexing it for search.
 * If the field is ANALYZED, the field will be tokenized, etc. for freeform search, and the only operator supported on
 * the query will be the MATCHES operator.
 * This means that variations of the value used in the query field should return the result.
 * For example: if you set a field this way and added the value 'San Francisco',
 * a query that passed in MATCHES 'San Francisco' would return this field.
 * Passing in MATCHES 'San', or MATCHES 'san', or MATCHES 'Francisco' would ALSO return this field.
 * If the field is NOT_ANALYZED, the field will NOT be tokenized etc. for freeform search.
 * This means that only an exact match on the query field value will return a result.
 * For example: if you set a field this way and added the value 'San Francisco',
 * only a query that passed in 'San Francisco' would return this field.
 * Passing in 'San' or 'san' 'Francisco' would not return this field.
 */
var QueryFieldIndexAnalyzedOption;
(function (QueryFieldIndexAnalyzedOption) {
    /**
     * The field will be indexed as an Analyzed (tokenized, etc.) field, to support the MATCHES QueryOperator.
     * USE SPARINGLY: Any field that is analyzed requires more memory, more processing, time to index, time to search, etc.
     */
    QueryFieldIndexAnalyzedOption["Analyzed"] = "ANALYZED";
    /**
     * The field is both Analyzed (tokenized, etc.) to support the MATCHES QueryOperator,
     * and Not Analyzed, to support other QueryOperators.
     * USE SPARINGLY: Requires us to index 2 different fields. Any field that is analyzed requires more memory,
     * more processing, time to index, time to search, etc.
     */
    QueryFieldIndexAnalyzedOption["BothAnalyzedAndNotAnalyzed"] = "BOTH_ANALYZED_AND_NOT_ANALYZED";
    /** The field will be indexed as NOT Analyzed, to support other QueryOperators besides MATCHES. */
    QueryFieldIndexAnalyzedOption["NotAnalyzed"] = "NOT_ANALYZED";
})(QueryFieldIndexAnalyzedOption || (exports.QueryFieldIndexAnalyzedOption = QueryFieldIndexAnalyzedOption = {}));
/** Enumerates the possible Query Operators. */
var QueryOperator;
(function (QueryOperator) {
    /** Equals (=) */
    QueryOperator["Eq"] = "EQ";
    /** Greater Than (>) */
    QueryOperator["Gt"] = "GT";
    /** Greater Than or Equal to (>=) */
    QueryOperator["Gte"] = "GTE";
    /** In (in) */
    QueryOperator["In"] = "IN";
    /** Less Than (<) */
    QueryOperator["Lt"] = "LT";
    /** Less Than or Equal To (<=) */
    QueryOperator["Lte"] = "LTE";
    /** Matches (matches). Use for Freeform search on a field. */
    QueryOperator["Matches"] = "MATCHES";
    /** Not Equals (!=) */
    QueryOperator["Neq"] = "NEQ";
    /** Not In (nin) */
    QueryOperator["Nin"] = "NIN";
})(QueryOperator || (exports.QueryOperator = QueryOperator = {}));
/** Enum that defines all quilt item types. */
var QuiltItemType;
(function (QuiltItemType) {
    QuiltItemType["Footer"] = "FOOTER";
    QuiltItemType["Header"] = "HEADER";
    QuiltItemType["List"] = "LIST";
})(QuiltItemType || (exports.QuiltItemType = QuiltItemType = {}));
/** An enumeration that defines the status of a rank. */
var RankStatus;
(function (RankStatus) {
    /** The rank is active. */
    RankStatus["Active"] = "ACTIVE";
    /** The rank is deleted. */
    RankStatus["Deleted"] = "DELETED";
})(RankStatus || (exports.RankStatus = RankStatus = {}));
/** An enumeration that defines the style of a rank's label. */
var RankStyle;
(function (RankStyle) {
    /** Displays a filled rank. */
    RankStyle["Filled"] = "FILLED";
    /** Displays an outline rank. */
    RankStyle["Outline"] = "OUTLINE";
    /** Displays only the text label. */
    RankStyle["Text"] = "TEXT";
})(RankStyle || (exports.RankStyle = RankStyle = {}));
/** An enumeration that defines the read state of a private conversation. */
var ReadState;
(function (ReadState) {
    /** The conversation is read. */
    ReadState["Read"] = "READ";
    /** The conversation is unread. */
    ReadState["Unread"] = "UNREAD";
})(ReadState || (exports.ReadState = ReadState = {}));
/** An enumeration that defines the registration status of a user. */
var RegistrationStatus;
(function (RegistrationStatus) {
    /** The user is anonymous and has not completed any registration. */
    RegistrationStatus["Anonymous"] = "ANONYMOUS";
    /** The user is fully registered. */
    RegistrationStatus["FullyRegistered"] = "FULLY_REGISTERED";
    /** The user is partially registered. */
    RegistrationStatus["PartiallyRegistered"] = "PARTIALLY_REGISTERED";
})(RegistrationStatus || (exports.RegistrationStatus = RegistrationStatus = {}));
/** An enumeration that defines the registration status access level of a user. */
var RegistrationStatusAccessLevel;
(function (RegistrationStatusAccessLevel) {
    /** The user is able to do both the read and write operations. */
    RegistrationStatusAccessLevel["All"] = "ALL";
    /** No registration status. */
    RegistrationStatusAccessLevel["None"] = "NONE";
    /** The user is able to do read operations (view most content), but cannot do write operations (post, give kudos, etc.). */
    RegistrationStatusAccessLevel["View"] = "VIEW";
})(RegistrationStatusAccessLevel || (exports.RegistrationStatusAccessLevel = RegistrationStatusAccessLevel = {}));
/** An enumeration representing reject reason. */
var RejectReason;
(function (RejectReason) {
    RejectReason["Abuse"] = "ABUSE";
    RejectReason["Other"] = "OTHER";
    RejectReason["Spam"] = "SPAM";
})(RejectReason || (exports.RejectReason = RejectReason = {}));
/** An enumeration that defines the format for replies. */
var RepliesFormat;
(function (RepliesFormat) {
    /** Linear replies format. */
    RepliesFormat["Linear"] = "linear";
    /** Threaded replies format. */
    RepliesFormat["Threaded"] = "threaded";
})(RepliesFormat || (exports.RepliesFormat = RepliesFormat = {}));
/** An enumeration that defines the sort order for replies. */
var RepliesSortOrder;
(function (RepliesSortOrder) {
    /** Sort replies based on likes. */
    RepliesSortOrder["Likes"] = "LIKES";
    /** Sort replies based on creation time. */
    RepliesSortOrder["PublishTime"] = "PUBLISH_TIME";
    /** Sort replies based on reverse creation time. */
    RepliesSortOrder["ReversePublishTime"] = "REVERSE_PUBLISH_TIME";
})(RepliesSortOrder || (exports.RepliesSortOrder = RepliesSortOrder = {}));
/** An enumeration representing what type of reply a message is. */
var ReplyType;
(function (ReplyType) {
    /** This message is an answer to a question. */
    ReplyType["Answer"] = "ANSWER";
    /** This message is a comment on another message. */
    ReplyType["Comment"] = "COMMENT";
    /** This message is a reply to another message. */
    ReplyType["Reply"] = "REPLY";
})(ReplyType || (exports.ReplyType = ReplyType = {}));
var ReportType;
(function (ReportType) {
    ReportType["BlogBoardReport"] = "BLOG_BOARD_REPORT";
    ReportType["BlogPostsReport"] = "BLOG_POSTS_REPORT";
    ReportType["CategoryReport"] = "CATEGORY_REPORT";
    ReportType["ForumBoardReport"] = "FORUM_BOARD_REPORT";
    ReportType["ForumDiscussionsReport"] = "FORUM_DISCUSSIONS_REPORT";
    ReportType["GrouphubReport"] = "GROUPHUB_REPORT";
    ReportType["IdeasReport"] = "IDEAS_REPORT";
    ReportType["IdeaBoardReport"] = "IDEA_BOARD_REPORT";
    ReportType["MemberReport"] = "MEMBER_REPORT";
    ReportType["OccasionsReport"] = "OCCASIONS_REPORT";
    ReportType["OccasionBoardReport"] = "OCCASION_BOARD_REPORT";
    ReportType["TkbArticlesReport"] = "TKB_ARTICLES_REPORT";
    ReportType["TkbBoardReport"] = "TKB_BOARD_REPORT";
})(ReportType || (exports.ReportType = ReportType = {}));
/** RSVP Response enum. */
var RsvpResponse;
(function (RsvpResponse) {
    /** RSVP response if one is uncertain of their presence for the occasion. */
    RsvpResponse["Maybe"] = "MAYBE";
    /** RSVP response if one is not willing to attend the occasion. */
    RsvpResponse["No"] = "NO";
    /** RSVP response if one is willing to attend the occasion. */
    RsvpResponse["Yes"] = "YES";
})(RsvpResponse || (exports.RsvpResponse = RsvpResponse = {}));
/** Enum consisting of different actions of Salesforce sync. */
var SalesforceUserSyncAction;
(function (SalesforceUserSyncAction) {
    /** If action is Reset. */
    SalesforceUserSyncAction["Reset"] = "RESET";
    /** If action is UserSync. */
    SalesforceUserSyncAction["Usersync"] = "USERSYNC";
})(SalesforceUserSyncAction || (exports.SalesforceUserSyncAction = SalesforceUserSyncAction = {}));
/** Enum consisting of different statuses of User sync. */
var SalesforceUserSyncStatus;
(function (SalesforceUserSyncStatus) {
    /** Status when userSync/reset is successfully completed. */
    SalesforceUserSyncStatus["Completed"] = "COMPLETED";
    /** Status when userSync/reset has failed. */
    SalesforceUserSyncStatus["Failed"] = "FAILED";
    /** Status when userSync/reset is in progress */
    SalesforceUserSyncStatus["Inprogress"] = "INPROGRESS";
})(SalesforceUserSyncStatus || (exports.SalesforceUserSyncStatus = SalesforceUserSyncStatus = {}));
/** Defines scheduling intervals */
var SchedulingInterval;
(function (SchedulingInterval) {
    SchedulingInterval["Daily"] = "DAILY";
    SchedulingInterval["Monthly"] = "MONTHLY";
    SchedulingInterval["Now"] = "NOW";
    SchedulingInterval["Weekly"] = "WEEKLY";
})(SchedulingInterval || (exports.SchedulingInterval = SchedulingInterval = {}));
/** An enumeration that defines which key matched while looking for the search term. */
var SearchSnippetKey;
(function (SearchSnippetKey) {
    /** Search snippet is for the Message Attachment file name. */
    SearchSnippetKey["AttachmentFileName"] = "ATTACHMENT_FILE_NAME";
    /** This search snippet is for the user biography. */
    SearchSnippetKey["Biography"] = "BIOGRAPHY";
    /** Search snippet is for the message body. */
    SearchSnippetKey["Body"] = "BODY";
    /** This search snippet is user email. */
    SearchSnippetKey["Email"] = "EMAIL";
    /** This search snippet is for the user first name. */
    SearchSnippetKey["FirstName"] = "FIRST_NAME";
    /** This Search snippet is for the user last logged in IP address. */
    SearchSnippetKey["IpAddress"] = "IP_ADDRESS";
    /** This search snippet is user last name. */
    SearchSnippetKey["LastName"] = "LAST_NAME";
    /** This search snippet is the user login ID. */
    SearchSnippetKey["Login"] = "LOGIN";
    /** This search snippet is for the node description */
    SearchSnippetKey["NodeDescription"] = "NODE_DESCRIPTION";
    /** Search snippet is for the message subject. */
    SearchSnippetKey["Subject"] = "SUBJECT";
    /** Search snippet is for the message tag. */
    SearchSnippetKey["Tags"] = "TAGS";
    /** Search snippet is for the message teaser. */
    SearchSnippetKey["Teaser"] = "TEASER";
    /** This search snippet is for the node title. */
    SearchSnippetKey["Title"] = "TITLE";
    /** This search snippet is for the user rank. */
    SearchSnippetKey["UserRank"] = "USER_RANK";
})(SearchSnippetKey || (exports.SearchSnippetKey = SearchSnippetKey = {}));
/** Enum consisting of different types of section or edit level. */
var SectionEditLevel;
(function (SectionEditLevel) {
    /** Removes the ability to delete a section, but allows for section configuration and reposition. */
    SectionEditLevel["Configure"] = "CONFIGURE";
    /** Allows the user to reposition, configure, and delete a section. */
    SectionEditLevel["Full"] = "FULL";
    /** Only allows reposition of the section. */
    SectionEditLevel["Locked"] = "LOCKED";
})(SectionEditLevel || (exports.SectionEditLevel = SectionEditLevel = {}));
/** Enum that defines all the section types. */
var SectionLayoutType;
(function (SectionLayoutType) {
    SectionLayoutType["MainSide"] = "MAIN_SIDE";
    SectionLayoutType["OneColumn"] = "ONE_COLUMN";
    SectionLayoutType["SideMain"] = "SIDE_MAIN";
    SectionLayoutType["ThreeColumn"] = "THREE_COLUMN";
    SectionLayoutType["TwoColumn"] = "TWO_COLUMN";
})(SectionLayoutType || (exports.SectionLayoutType = SectionLayoutType = {}));
/** Enumeration specifying who to show a user's email address to. */
var ShowEmailTo;
(function (ShowEmailTo) {
    /** Show everyone (including anonymous users) the user's email address. */
    ShowEmailTo["All"] = "ALL";
    /** Only show the user's email address to the friends of the user. */
    ShowEmailTo["FriendsOnly"] = "FRIENDS_ONLY";
    /** Never show the user's email address (except to moderators). */
    ShowEmailTo["None"] = "NONE";
})(ShowEmailTo || (exports.ShowEmailTo = ShowEmailTo = {}));
/** Enumeration specifying who to show a user's online status to. */
var ShowOnlineStatusTo;
(function (ShowOnlineStatusTo) {
    /** Show everyone (including anonymous users) when the user is online. */
    ShowOnlineStatusTo["All"] = "ALL";
    /** Only show friends of the user when the user is online. */
    ShowOnlineStatusTo["FriendsOnly"] = "FRIENDS_ONLY";
    /** Never show when the user is online (except to moderators). */
    ShowOnlineStatusTo["None"] = "NONE";
})(ShowOnlineStatusTo || (exports.ShowOnlineStatusTo = ShowOnlineStatusTo = {}));
/** Enumeration specifying who to show a user's profile information. */
var ShowProfileInformationTo;
(function (ShowProfileInformationTo) {
    /** Show everyone (including anonymous users) the user's profile information. */
    ShowProfileInformationTo["All"] = "ALL";
    /** Only show the user's profile information to the friends of the user. */
    ShowProfileInformationTo["FriendsOnly"] = "FRIENDS_ONLY";
    /** Never show the user's profile information (except to moderators). */
    ShowProfileInformationTo["None"] = "NONE";
})(ShowProfileInformationTo || (exports.ShowProfileInformationTo = ShowProfileInformationTo = {}));
/** An enumeration that defines the signed in status of a user. */
var SignedInStatus;
(function (SignedInStatus) {
    /** The user is anonymous and is not signed in. */
    SignedInStatus["Anonymous"] = "ANONYMOUS";
    /** Applies for both, signed in and anonymous users. */
    SignedInStatus["Both"] = "BOTH";
    /** The user is signed in. */
    SignedInStatus["SignedIn"] = "SIGNED_IN";
})(SignedInStatus || (exports.SignedInStatus = SignedInStatus = {}));
/** Defines an enum for the sort direction to use in a sort. */
var SortDirection;
(function (SortDirection) {
    /** Sort in the ascending direction. */
    SortDirection["Asc"] = "ASC";
    /** Sort in the descending direction. */
    SortDirection["Desc"] = "DESC";
})(SortDirection || (exports.SortDirection = SortDirection = {}));
/** Post spam status enum. */
var SpamStatus;
(function (SpamStatus) {
    SpamStatus["NotSpammed"] = "NOT_SPAMMED";
    SpamStatus["Spammed"] = "SPAMMED";
})(SpamStatus || (exports.SpamStatus = SpamStatus = {}));
var SpecialChecksValidation;
(function (SpecialChecksValidation) {
    /** Verifies that a string has allowed ports */
    SpecialChecksValidation["HasAllowedPort"] = "HAS_ALLOWED_PORT";
    /** Verifies that a string contains a digit. */
    SpecialChecksValidation["HasDigit"] = "HAS_DIGIT";
    /** Verifies that a string contains a letter. */
    SpecialChecksValidation["HasLetter"] = "HAS_LETTER";
    /** Verifies that a string contains a lower case letter */
    SpecialChecksValidation["HasLower"] = "HAS_LOWER";
    /** Verifies that a string no contain at(@) symbol. */
    SpecialChecksValidation["HasNoAtSymbol"] = "HAS_NO_AT_SYMBOL";
    /** Verifies that a string does not contain HTML. */
    SpecialChecksValidation["HasNoHtml"] = "HAS_NO_HTML";
    /** Verifies that a string has no repeated sequence of characters of PASS_SEQ or more characters. */
    SpecialChecksValidation["HasNoRepeat"] = "HAS_NO_REPEAT";
    /** Verifies that a string has no spaces. */
    SpecialChecksValidation["HasNoSpace"] = "HAS_NO_SPACE";
    /** Verifies that a string has no unsafe uri characters. */
    SpecialChecksValidation["HasNoUriPathElementUnsafeCharacters"] = "HAS_NO_URI_PATH_ELEMENT_UNSAFE_CHARACTERS";
    /** Validates whether a given input string contains a URL anywhere within the string. */
    SpecialChecksValidation["HasNoUrls"] = "HAS_NO_URLS";
    /** Verifies that a string only contains alphanumeric characters. Valid characters: a-z, A-Z, and 0-9, and also - and _. */
    SpecialChecksValidation["HasOnlyAlphaNumeric"] = "HAS_ONLY_ALPHA_NUMERIC";
    /** Verifies that a string only contains alphanumeric characters. Valid characters: a-z, A-Z, and 0-9, and * also - and _ and @. */
    SpecialChecksValidation["HasOnlyAlphaNumericOrAt"] = "HAS_ONLY_ALPHA_NUMERIC_OR_AT";
    /** Verifies that a string only contains alphanumeric characters. Valid characters: a-z, A-Z, and 0-9, - and _, and space (u0020). */
    SpecialChecksValidation["HasOnlyAlphaNumericOrHyphenUnderscoreDot"] = "HAS_ONLY_ALPHA_NUMERIC_OR_HYPHEN_UNDERSCORE_DOT";
    /** Checks if a string contains only alphanumeric characters or spaces. */
    SpecialChecksValidation["HasOnlyAlphaNumericOrSpaces"] = "HAS_ONLY_ALPHA_NUMERIC_OR_SPACES";
    /** Validates if a string contains only alphanumeric characters or underscores ('_'). */
    SpecialChecksValidation["HasOnlyAlphaNumericOrUnderscore"] = "HAS_ONLY_ALPHA_NUMERIC_OR_UNDERSCORE";
    /** Verifies if a string consists only of Unicode alphanumeric characters. This includes letters (uppercase and lowercase). */
    SpecialChecksValidation["HasOnlyUnicodeAlphaNumeric"] = "HAS_ONLY_UNICODE_ALPHA_NUMERIC";
    /** Verifies that a string only contains unicode letters, numbers, -, _, whitespace. */
    SpecialChecksValidation["HasOnlyUnicodeAlphaNumericOrSpaces"] = "HAS_ONLY_UNICODE_ALPHA_NUMERIC_OR_SPACES";
    /** Validates that the string contains a valid Special Character. */
    SpecialChecksValidation["HasSpecialChar"] = "HAS_SPECIAL_CHAR";
    /** Verifies that a string contains an upper case letter. */
    SpecialChecksValidation["HasUpper"] = "HAS_UPPER";
    /** Verifies that a string contains a hexadecimal RBG color. */
    SpecialChecksValidation["IsColor"] = "IS_COLOR";
    /** Verifies that  a string contains a list of valid URLs or is blank. This enforces a valid protocol specifier and the URI syntax. */
    SpecialChecksValidation["IsCommaSeparatedUrls"] = "IS_COMMA_SEPARATED_URLS";
    /** Verifies that a string is either empty or a valid csv list of non-negative integers with no duplicates. */
    SpecialChecksValidation["IsCsvNoDupsNonNegativeIntList"] = "IS_CSV_NO_DUPS_NON_NEGATIVE_INT_LIST";
    /** Verifies that a string is a valid date. */
    SpecialChecksValidation["IsDate"] = "IS_DATE";
    /** Verifies that a string is a valid date format. */
    SpecialChecksValidation["IsDateFormat"] = "IS_DATE_FORMAT";
    /** Verifies that a string is a valid date time. */
    SpecialChecksValidation["IsDateTime"] = "IS_DATE_TIME";
    /** Verifies that a string has  valid date format without time component. */
    SpecialChecksValidation["IsDateWithoutTimeFormat"] = "IS_DATE_WITHOUT_TIME_FORMAT";
    /** Verifies that a string is divisor of 24. */
    SpecialChecksValidation["IsDivisorOf_24"] = "IS_DIVISOR_OF_24";
    /** Verifies if a string is a valid email address format. */
    SpecialChecksValidation["IsEmail"] = "IS_EMAIL";
    /** Verifies that a multiple string looks like a valid e-mail address. */
    SpecialChecksValidation["IsEmailList"] = "IS_EMAIL_LIST";
    /** Verifies that a string looks like a valid URL and starts with either http:// or https://, or is blank. */
    SpecialChecksValidation["IsHttpOrHttps"] = "IS_HTTP_OR_HTTPS";
    /** Is the input a single valid IP address. */
    SpecialChecksValidation["IsIp"] = "IS_IP";
    /** Verifies that the string specifies a date in a format compatible with ISO 8601. */
    SpecialChecksValidation["IsIso_8601DateTime"] = "IS_ISO_8601_DATE_TIME";
    /** Verifies that a string is long value */
    SpecialChecksValidation["IsLong"] = "IS_LONG";
    /** Is the input a single valid IP address with optional mask. */
    SpecialChecksValidation["IsMaskedIp"] = "IS_MASKED_IP";
    /** Is the input a valid list of IP addresses with optional masks. */
    SpecialChecksValidation["IsMaskedIpList"] = "IS_MASKED_IP_LIST";
    /** Verifies that a string only contains lowercase letters a-z, periods('.') and underscores ('_').In addition, the key must begin and end with a lowercase letter, and may not contain adjacent periods or underscores. */
    SpecialChecksValidation["IsMetaDataKey"] = "IS_META_DATA_KEY";
    /** Verifies that a string only contains lowercase letters a-z, periods('.') and underscores ('_'). In addition, the key must begin and end with a lowercase letter, and may not contain adjacent periods or underscores. */
    SpecialChecksValidation["IsMetaDataValueKey"] = "IS_META_DATA_VALUE_KEY";
    /** Verifies that a string only contains lowercase letters a-z, periods('.') and underscores ('_'). In addition, the key must begin and end with a lowercase letter, and may not contain adjacent periods or underscores. */
    SpecialChecksValidation["IsMetaDataValueKeyOrBlank"] = "IS_META_DATA_VALUE_KEY_OR_BLANK";
    /** Verifies that the given string represents a valid Rest API data/time. */
    SpecialChecksValidation["IsRestDateTime"] = "IS_REST_DATE_TIME";
    /** Verifies that a string is a valid role. */
    SpecialChecksValidation["IsRole"] = "IS_ROLE";
    /** Verifies that a password string is considered strong. */
    SpecialChecksValidation["IsStrongPassword"] = "IS_STRONG_PASSWORD";
    /** Verifies that a string is a valid time. */
    SpecialChecksValidation["IsTimeFormat"] = "IS_TIME_FORMAT";
    /** Verifies that  a string looks like a valid URI or is blank. The parses and enforces URI syntax only. */
    SpecialChecksValidation["IsUri"] = "IS_URI";
    /** Verifies that  a string looks like a valid URL or is blank. This enforces a valid protocol specifier and the URI syntax. */
    SpecialChecksValidation["IsUrl"] = "IS_URL";
    /** Verifies that  a string looks like a valid URL or relative URL path or is blank. */
    SpecialChecksValidation["IsUrlOrRelativePath"] = "IS_URL_OR_RELATIVE_PATH";
    /** Validates that the string entered maps to a legal avatar crop prop. */
    SpecialChecksValidation["IsValidAvatarCropProp"] = "IS_VALID_AVATAR_CROP_PROP";
    /** Validates that a string entered maps to a legal charset. */
    SpecialChecksValidation["IsValidCharset"] = "IS_VALID_CHARSET";
    /** Verifies that a string is a valid domain name */
    SpecialChecksValidation["IsValidDomainName"] = "IS_VALID_DOMAIN_NAME";
    /** Verifies that a string is a valid domain name list */
    SpecialChecksValidation["IsValidDomainNameList"] = "IS_VALID_DOMAIN_NAME_LIST";
    /** Verifies that a string is a valid file extension */
    SpecialChecksValidation["IsValidFileExtension"] = "IS_VALID_FILE_EXTENSION";
    /** Verifies that a string is a valid HTML tag name */
    SpecialChecksValidation["IsValidHtmlTagName"] = "IS_VALID_HTML_TAG_NAME";
    /** Verifies that  a string looks like a valid URL (possible without protocol if it starts with 'www.') or is blank. This enforces a valid protocol. */
    SpecialChecksValidation["IsWww"] = "IS_WWW";
    /** Indicates whether to display or hide a field */
    SpecialChecksValidation["ShowHidden"] = "SHOW_HIDDEN";
})(SpecialChecksValidation || (exports.SpecialChecksValidation = SpecialChecksValidation = {}));
/** Defines an enumeration for statuses in private notes and conversations. */
var StatusType;
(function (StatusType) {
    StatusType["Active"] = "ACTIVE";
    StatusType["All"] = "ALL";
    StatusType["Rejected"] = "REJECTED";
})(StatusType || (exports.StatusType = StatusType = {}));
/** Enumerates the types of string form fields */
var StringCustomFormFieldType;
(function (StringCustomFormFieldType) {
    /** An input field. */
    StringCustomFormFieldType["Input"] = "INPUT";
    /** A password field */
    StringCustomFormFieldType["Password"] = "PASSWORD";
    /** A radio field. */
    StringCustomFormFieldType["Radio"] = "RADIO";
    /** A rich text editor field. */
    StringCustomFormFieldType["Rte"] = "RTE";
    /** A select field. */
    StringCustomFormFieldType["Select"] = "SELECT";
    /** A textarea field. */
    StringCustomFormFieldType["Textarea"] = "TEXTAREA";
})(StringCustomFormFieldType || (exports.StringCustomFormFieldType = StringCustomFormFieldType = {}));
/** Enumerates the types of list string form fields */
var StringListCustomFormFieldType;
(function (StringListCustomFormFieldType) {
    /** A select field. */
    StringListCustomFormFieldType["Select"] = "SELECT";
})(StringListCustomFormFieldType || (exports.StringListCustomFormFieldType = StringListCustomFormFieldType = {}));
/** Enumerates the possible Query Operators for String values. */
var StringQueryOperator;
(function (StringQueryOperator) {
    /** Equals (=) */
    StringQueryOperator["Eq"] = "EQ";
    /** In (in) */
    StringQueryOperator["In"] = "IN";
    /** Matches (matches). Use for Freeform search on a field. */
    StringQueryOperator["Matches"] = "MATCHES";
    /** Not Equals (!=) */
    StringQueryOperator["Neq"] = "NEQ";
    /** Not In (nin) */
    StringQueryOperator["Nin"] = "NIN";
})(StringQueryOperator || (exports.StringQueryOperator = StringQueryOperator = {}));
/** Defines enum for all applicable sort metrics for TKBArticlesReport. */
var TkbArticlesReportSortMetric;
(function (TkbArticlesReportSortMetric) {
    /** Number of the KB replies. */
    TkbArticlesReportSortMetric["CommentsPublished"] = "COMMENTS_PUBLISHED";
    /** Number of helpful votes. */
    TkbArticlesReportSortMetric["HelpfulVotes"] = "HELPFUL_VOTES";
    /** Likes given. */
    TkbArticlesReportSortMetric["KudosGiven"] = "KUDOS_GIVEN";
    /**
     * A page view is counted each time a browser requests a page, regardless of the device type or whether the page is
     * cached. Page views approximates user behavior and therefore excludes non-human requests (Web crawlers,
     * robots, RSS feeds, REST API calls, ActiveCast calls, and LevelUp requests).
     */
    TkbArticlesReportSortMetric["PageViews"] = "PAGE_VIEWS";
    /** Number of subscriptions made on articles. */
    TkbArticlesReportSortMetric["PostSubscriptions"] = "POST_SUBSCRIPTIONS";
    /** Number of unhelpful votes. */
    TkbArticlesReportSortMetric["UnhelpfulVotes"] = "UNHELPFUL_VOTES";
    /** Unique number of visitors. */
    TkbArticlesReportSortMetric["UniqueVisitors"] = "UNIQUE_VISITORS";
    /** A visit is one or more page views over time by a uniquely identified client (visitor). */
    TkbArticlesReportSortMetric["Visits"] = "VISITS";
})(TkbArticlesReportSortMetric || (exports.TkbArticlesReportSortMetric = TkbArticlesReportSortMetric = {}));
/** Defines enum for all applicable sort metrics for tkbBoardReport. */
var TkbBoardReportSortMetric;
(function (TkbBoardReportSortMetric) {
    /** Number of the KB articles published. */
    TkbBoardReportSortMetric["ArticlesPublished"] = "ARTICLES_PUBLISHED";
    /** Number of the KB replies. */
    TkbBoardReportSortMetric["CommentsPublished"] = "COMMENTS_PUBLISHED";
    /** Number of helpful votes. */
    TkbBoardReportSortMetric["HelpfulVotes"] = "HELPFUL_VOTES";
    /** Likes given. */
    TkbBoardReportSortMetric["KudosGiven"] = "KUDOS_GIVEN";
    /** Number of subscriptions made on nodes. */
    TkbBoardReportSortMetric["NodeSubscriptions"] = "NODE_SUBSCRIPTIONS";
    /**
     * A page view is counted each time a browser requests a page, regardless of the device type or whether the page is
     * cached. Page views approximates user behavior and therefore excludes non-human requests (Web crawlers,
     * robots, RSS feeds, REST API calls, ActiveCast calls, and LevelUp requests).
     */
    TkbBoardReportSortMetric["PageViews"] = "PAGE_VIEWS";
    /** Number of unhelpful votes. */
    TkbBoardReportSortMetric["UnhelpfulVotes"] = "UNHELPFUL_VOTES";
    /** Unique number of visitors. */
    TkbBoardReportSortMetric["UniqueVisitors"] = "UNIQUE_VISITORS";
    /** A visit is one or more page views over time by a uniquely identified client (visitor). */
    TkbBoardReportSortMetric["Visits"] = "VISITS";
})(TkbBoardReportSortMetric || (exports.TkbBoardReportSortMetric = TkbBoardReportSortMetric = {}));
/** Enum that defines all allowed tag types. */
var TagType;
(function (TagType) {
    TagType["FreeformAndPreset"] = "FREEFORM_AND_PRESET";
    TagType["FreeformOnly"] = "FREEFORM_ONLY";
    TagType["PresetOnly"] = "PRESET_ONLY";
})(TagType || (exports.TagType = TagType = {}));
/** Text alignment enum. */
var TextAlignment;
(function (TextAlignment) {
    TextAlignment["Center"] = "CENTER";
    TextAlignment["Left"] = "LEFT";
    TextAlignment["Right"] = "RIGHT";
})(TextAlignment || (exports.TextAlignment = TextAlignment = {}));
var TextItemGroup;
(function (TextItemGroup) {
    /** Text item for badges */
    TextItemGroup["Badges"] = "BADGES";
    /** Custom text item */
    TextItemGroup["Custom"] = "CUSTOM";
    /** Text item for emails */
    TextItemGroup["Emails"] = "EMAILS";
    /** Text item for ranks */
    TextItemGroup["Ranks"] = "RANKS";
})(TextItemGroup || (exports.TextItemGroup = TextItemGroup = {}));
/** Defines an enum for the text-transform css property. */
var TextTransform;
(function (TextTransform) {
    TextTransform["Capitalize"] = "CAPITALIZE";
    TextTransform["FullSizeKana"] = "FULL_SIZE_KANA";
    TextTransform["FullWidth"] = "FULL_WIDTH";
    TextTransform["Lowercase"] = "LOWERCASE";
    TextTransform["None"] = "NONE";
    TextTransform["Uppercase"] = "UPPERCASE";
})(TextTransform || (exports.TextTransform = TextTransform = {}));
/** Defines time durations at a given unit of granularity. */
var TimeUnit;
(function (TimeUnit) {
    /** The duration is measured in days */
    TimeUnit["Days"] = "DAYS";
    /** The duration is measured in hours */
    TimeUnit["Hours"] = "HOURS";
    /** The duration is measured in milliseconds */
    TimeUnit["Milliseconds"] = "MILLISECONDS";
    /** The duration is measured in minutes */
    TimeUnit["Minutes"] = "MINUTES";
    /** The duration is measured in seconds */
    TimeUnit["Seconds"] = "SECONDS";
})(TimeUnit || (exports.TimeUnit = TimeUnit = {}));
/** A toggle state. */
var ToggleState;
(function (ToggleState) {
    /** The closed state. */
    ToggleState["Closed"] = "closed";
    /** The open state. */
    ToggleState["Open"] = "open";
})(ToggleState || (exports.ToggleState = ToggleState = {}));
/** Token method to pass user's access token */
var TokenMethod;
(function (TokenMethod) {
    /** form_url_encoded token method */
    TokenMethod["FormUrlEncoded"] = "FORM_URL_ENCODED";
    /** json token method */
    TokenMethod["Json"] = "JSON";
    /** None token method */
    TokenMethod["None"] = "NONE";
})(TokenMethod || (exports.TokenMethod = TokenMethod = {}));
/** Enum defining the topic trending window inside which the topic should be trending. */
var TopicTrendingWindow;
(function (TopicTrendingWindow) {
    TopicTrendingWindow["FiveDays"] = "FIVE_DAYS";
    TopicTrendingWindow["FourDays"] = "FOUR_DAYS";
    TopicTrendingWindow["OneDay"] = "ONE_DAY";
    TopicTrendingWindow["SevenDays"] = "SEVEN_DAYS";
    TopicTrendingWindow["SixDays"] = "SIX_DAYS";
    TopicTrendingWindow["ThreeDays"] = "THREE_DAYS";
    TopicTrendingWindow["TwoDays"] = "TWO_DAYS";
})(TopicTrendingWindow || (exports.TopicTrendingWindow = TopicTrendingWindow = {}));
var TopicsByRepliesType;
(function (TopicsByRepliesType) {
    /** All topics with and without replies, with and without accepted solutions. */
    TopicsByRepliesType["AllTopics"] = "ALL_TOPICS";
    /** All topics that do not have accepted solutions. */
    TopicsByRepliesType["WithoutAcceptedSolutions"] = "WITHOUT_ACCEPTED_SOLUTIONS";
    /** All topics that do not have replies. */
    TopicsByRepliesType["WithoutReplies"] = "WITHOUT_REPLIES";
    /** All topics that have accepted solutions. */
    TopicsByRepliesType["WithAcceptedSolutions"] = "WITH_ACCEPTED_SOLUTIONS";
    /** All topics that have replies. */
    TopicsByRepliesType["WithReplies"] = "WITH_REPLIES";
})(TopicsByRepliesType || (exports.TopicsByRepliesType = TopicsByRepliesType = {}));
var TrafficMetricDrillDownByType;
(function (TrafficMetricDrillDownByType) {
    /** Traffic metric drill down by board */
    TrafficMetricDrillDownByType["Board"] = "BOARD";
    /** Traffic metric drill down by topic */
    TrafficMetricDrillDownByType["Topic"] = "TOPIC";
})(TrafficMetricDrillDownByType || (exports.TrafficMetricDrillDownByType = TrafficMetricDrillDownByType = {}));
/** Defines enum for all applicable sort metrics for trendingTopicByRepliesReport. */
var TrendingTopicsByRepliesReportSortMetric;
(function (TrendingTopicsByRepliesReportSortMetric) {
    /** Likes given. */
    TrendingTopicsByRepliesReportSortMetric["KudosGiven"] = "KUDOS_GIVEN";
    /**
     * A page view is counted each time a browser requests a page, regardless of the device type or whether the page is
     * cached. Page Views approximates user behavior and therefore excludes non-human requests (Web crawlers,
     * robots, RSS feeds, REST API calls, ActiveCast calls, and LevelUp requests).
     */
    TrendingTopicsByRepliesReportSortMetric["PageViews"] = "PAGE_VIEWS";
    /** Replies published. */
    TrendingTopicsByRepliesReportSortMetric["RepliesPublished"] = "REPLIES_PUBLISHED";
})(TrendingTopicsByRepliesReportSortMetric || (exports.TrendingTopicsByRepliesReportSortMetric = TrendingTopicsByRepliesReportSortMetric = {}));
var Trigger;
(function (Trigger) {
    Trigger["RequestToJoinNode"] = "REQUEST_TO_JOIN_NODE";
    Trigger["RoleGranted"] = "ROLE_GRANTED";
    Trigger["UserEmailVerified"] = "USER_EMAIL_VERIFIED";
    Trigger["UserRegisters"] = "USER_REGISTERS";
})(Trigger || (exports.Trigger = Trigger = {}));
var UploadVideoStatus;
(function (UploadVideoStatus) {
    UploadVideoStatus["Error"] = "ERROR";
    UploadVideoStatus["Live"] = "LIVE";
    UploadVideoStatus["Paused"] = "PAUSED";
    UploadVideoStatus["Pending"] = "PENDING";
    UploadVideoStatus["Processing"] = "PROCESSING";
    UploadVideoStatus["Uploading"] = "UPLOADING";
})(UploadVideoStatus || (exports.UploadVideoStatus = UploadVideoStatus = {}));
var UploadedImageAssociatedEntityType;
(function (UploadedImageAssociatedEntityType) {
    UploadedImageAssociatedEntityType["Message"] = "MESSAGE";
    UploadedImageAssociatedEntityType["PrivateNote"] = "PRIVATE_NOTE";
})(UploadedImageAssociatedEntityType || (exports.UploadedImageAssociatedEntityType = UploadedImageAssociatedEntityType = {}));
/** An enumeration that defines the online status of a user. */
var UserOnlineStatus;
(function (UserOnlineStatus) {
    /** The user is offline. */
    UserOnlineStatus["Offline"] = "OFFLINE";
    /** The user is online. */
    UserOnlineStatus["Online"] = "ONLINE";
})(UserOnlineStatus || (exports.UserOnlineStatus = UserOnlineStatus = {}));
/** An enumeration that defines the sort order for replies. */
var UserRepliesSortOrder;
(function (UserRepliesSortOrder) {
    /** Sort replies based on board default option. */
    UserRepliesSortOrder["Default"] = "DEFAULT";
    /** Sort replies based on likes. */
    UserRepliesSortOrder["Likes"] = "LIKES";
    /** Sort replies based on creation time. */
    UserRepliesSortOrder["PublishTime"] = "PUBLISH_TIME";
    /** Sort replies based on reverse creation time. */
    UserRepliesSortOrder["ReversePublishTime"] = "REVERSE_PUBLISH_TIME";
})(UserRepliesSortOrder || (exports.UserRepliesSortOrder = UserRepliesSortOrder = {}));
var UserType;
(function (UserType) {
    UserType["Anonymous"] = "ANONYMOUS";
    UserType["Member"] = "MEMBER";
})(UserType || (exports.UserType = UserType = {}));
var VideoAssociationType;
(function (VideoAssociationType) {
    /** The video association type is inline body. */
    VideoAssociationType["InlineBody"] = "INLINE_BODY";
    /** The video association type is inline teaser. */
    VideoAssociationType["InlineTeaser"] = "INLINE_TEASER";
})(VideoAssociationType || (exports.VideoAssociationType = VideoAssociationType = {}));
var VisibilityScope;
(function (VisibilityScope) {
    /** messages that are marked as archived. */
    VisibilityScope["Archived"] = "ARCHIVED";
    /** allow viewing draft messages */
    VisibilityScope["Draft"] = "DRAFT";
    /** messages that are on hold till author email is verified */
    VisibilityScope["OnHold"] = "ON_HOLD";
    /** Messages waiting for first-tier private_and_unmoderated */
    VisibilityScope["PrivateAndUnmoderated"] = "PRIVATE_AND_UNMODERATED";
    /** public messages */
    VisibilityScope["Public"] = "PUBLIC";
    /** allow viewing both public and draft messages  */
    VisibilityScope["PublicAndDraft"] = "PUBLIC_AND_DRAFT";
    /** Rejected messages */
    VisibilityScope["Rejected"] = "REJECTED";
})(VisibilityScope || (exports.VisibilityScope = VisibilityScope = {}));
/** Visual style enum. */
var VisualStyle;
(function (VisualStyle) {
    VisualStyle["Both"] = "BOTH";
    VisualStyle["Main"] = "MAIN";
    VisualStyle["Side"] = "SIDE";
})(VisualStyle || (exports.VisualStyle = VisualStyle = {}));
/** An enumeration representing the type of workflow action. */
var WorkflowAction;
(function (WorkflowAction) {
    /** Accept or Approve a forum message which has been nominated. */
    WorkflowAction["Accepted"] = "ACCEPTED";
    /** Cancel the schedule for publication, if any. */
    WorkflowAction["CancelSchedulePublication"] = "CANCEL_SCHEDULE_PUBLICATION";
    /** Nominate a forum message to the destination KB board. */
    WorkflowAction["Nominated"] = "NOMINATED";
    /** Publish the article. */
    WorkflowAction["Publish"] = "PUBLISH";
    /** Recall the article to the draft state. */
    WorkflowAction["Recall"] = "RECALL";
    /** Reject a forum message which has been nominated. */
    WorkflowAction["Rejected"] = "REJECTED";
    /** Return an article from review state back to the author. */
    WorkflowAction["ReturnToAuthor"] = "RETURN_TO_AUTHOR";
    /** Return an article from in approval state back to the editor. */
    WorkflowAction["ReturnToEditor"] = "RETURN_TO_EDITOR";
    /** Save the current state of the article as draft after create or edit of the article. */
    WorkflowAction["SaveDraft"] = "SAVE_DRAFT";
    /** Schedule an article for publication. */
    WorkflowAction["SchedulePublication"] = "SCHEDULE_PUBLICATION";
    /** Submit an article for publication by the publisher. */
    WorkflowAction["SubmitForPublication"] = "SUBMIT_FOR_PUBLICATION";
    /** Submit an article for a review from the editor or reviewer */
    WorkflowAction["SubmitForReview"] = "SUBMIT_FOR_REVIEW";
    /** Update the schedule time of the article which has already been scheduled for publication. */
    WorkflowAction["UpdateSchedulePublication"] = "UPDATE_SCHEDULE_PUBLICATION";
})(WorkflowAction || (exports.WorkflowAction = WorkflowAction = {}));
/** An enumeration representing the type of column filter. */
var WorkstreamColumnFilterType;
(function (WorkstreamColumnFilterType) {
    WorkstreamColumnFilterType["AbuseMessage"] = "ABUSE_MESSAGE";
    WorkstreamColumnFilterType["Moderation"] = "MODERATION";
    WorkstreamColumnFilterType["Spam"] = "SPAM";
})(WorkstreamColumnFilterType || (exports.WorkstreamColumnFilterType = WorkstreamColumnFilterType = {}));
/** An enumeration representing what type of scope the workstream is. */
var WorkstreamScope;
(function (WorkstreamScope) {
    /** This workstream is personal to the user. */
    WorkstreamScope["Personal"] = "PERSONAL";
    /** This workstream can be shared across. */
    WorkstreamScope["Shared"] = "SHARED";
})(WorkstreamScope || (exports.WorkstreamScope = WorkstreamScope = {}));
var ZoomMeetingStatus;
(function (ZoomMeetingStatus) {
    ZoomMeetingStatus["NotStarted"] = "NOT_STARTED";
    ZoomMeetingStatus["Started"] = "STARTED";
})(ZoomMeetingStatus || (exports.ZoomMeetingStatus = ZoomMeetingStatus = {}));
//# sourceMappingURL=graphql-schema-types.js.map